var qr = Object.defineProperty;
var Gr = (n, e, t) => e in n ? qr(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var v = (n, e, t) => (Gr(n, typeof e != "symbol" ? e + "" : e, t), t);
import * as p from "react";
import Yt from "react";
import { useEventCallback as Ht, enqueueSnackbar as qt, Accordion as wt, AccordionSummary as yt, sx as he, Typography as J, Alert as Ye, AccordionDetails as It, Box as C, Chip as vt, TextField as He, LoadingButton as bt, Button as Me, Drawer as Jr, IconButton as Ee, TypoTooltip as te, Link as Gt, Breadcrumbs as Kr, Dialog as Qr, DialogContent as Xr, Tooltip as xe, Badge as Jt, usePopupState as Kt, ButtonBase as at, bindToggle as Qt, Popper as Xt, bindPopper as Zt, ClickAwayListener as er, Paper as tr, Skeleton as Pe, Avatar as dt, useClipboard as Zr, useDebounceValue as en, Divider as zt, useFavicon as tn, useDocumentTitle as rn } from "@applift/factor";
import { useQuery as ke, useInfiniteQuery as nn } from "@tanstack/react-query";
import Q, { AxiosError as an } from "axios";
import { AppCustomers as on, AppDashboard as sn, AppReports as cn, AppBidModel as ln, AppOrganisation as un, AppMyProfile as dn, AppCampaigns as pn, AppAudiences as fn, AppCreatives as gn, AppInventory as hn, AppConversion as mn, AppInsights as wn, AppPlanner as yn, AppCampaignDebugger as In, AlertOctagon as Ve, Settings as vn, Close as bn, ChevronRight as _n, Message as Rn, GridDots as An, Copy as rr, Crown as Sn, ClipboardRemove as Ln, Search as xn, Home as En, QuestionCircle as kn } from "@applift/icons";
import { datadogRum as ze } from "@datadog/browser-rum";
import G from "clsx";
import { DigitalExperience as Dn } from "@applift/illustrations";
const H = () => {
  const n = window.location.host;
  return ["localhost", "127.0.0.1"].filter((t) => n.includes(t)).length > 0;
}, _t = (n) => {
  let e = "";
  try {
    e = new URL(n).origin;
  } catch {
    e = "";
  }
  return H() ? e ?? "" : window.location.origin;
}, Rt = (n = "") => n.replace(/^https?:\/\//, ""), Uo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getDomainURL: Rt,
  getOriginURL: _t,
  isLocalhost: H
}, Symbol.toStringTag, { value: "Module" })), On = {
  Customers: on,
  Dashboard: sn,
  Reports: cn,
  "Bid Model": ln,
  Organization: un,
  "My Profile": dn,
  Campaigns: pn,
  Audiences: fn,
  Creatives: gn,
  Inventory: hn,
  Conversions: mn,
  Insights: wn,
  Planner: yn,
  "Campaign Debugger": In,
  Marketplace: Ve,
  // Marketplace has no icon
  Messages: Ve,
  // Messages has no icon
  "Auth Pages": Ve
  // Messages has no icon
}, qe = {
  appId: -3,
  appName: "Auth Pages",
  appIcon: "logo/auth-pages.png",
  appUrl: "/",
  showInDrawer: !1
}, At = "Basic N3BuaWJrdWpleTFvanJnbnNsbjU6MTIzNDU2", P = {
  AUTH: "auth",
  LAST_OWID: "last_owid",
  LEGACY_OWIDS_ARRAY: "owIds",
  LEGACY_AUTH: "authorizedUser",
  LEGACY_INIT: "initData",
  INIT: "init",
  ORIGIN_URL: "ORIGIN_URL"
}, nr = "X-IAA-OW-ID", ar = "https://d64is2qkxbhv3.cloudfront.net/assets/dist", or = "https://d2v0lj9tfbnmhu.cloudfront.net/assets/dist", ce = {
  SUPER: "SUPER",
  WORKSPACE: "WORKSPACE",
  ADVERTISER: "ADVERTISER"
}, jn = {
  minDuration: 3,
  minDailyBudget: 100,
  minDailyImpressions: 1e3
}, nt = () => {
  var e;
  const n = window.location.href ?? "";
  try {
    const t = Number((e = n.match(/\/u\/[0-9]+/i)) == null ? void 0 : e[0].substring(3)), r = isNaN(t) ? 0 : t;
    return H() ? 0 : r;
  } catch {
    return 0;
  }
}, $e = (n) => {
  try {
    const e = JSON.parse(
      window.localStorage.getItem(P.LEGACY_OWIDS_ARRAY) ?? "[]"
    ), t = Number(n), r = e == null ? void 0 : e.map(Number);
    return Array.isArray(r) ? [r.indexOf(t), r] : [-1, []];
  } catch {
    return [-1, []];
  }
}, sr = (n) => {
  try {
    const e = JSON.parse(
      window.localStorage.getItem(P.LEGACY_OWIDS_ARRAY) ?? "[]"
    ), t = e == null ? void 0 : e.map(Number);
    if (Array.isArray(t)) {
      const r = Number(t[n]);
      return isNaN(r) ? null : r;
    } else
      return null;
  } catch {
    return null;
  }
}, ir = () => {
  const n = nt();
  return sr(n);
}, cr = () => {
  var t;
  let n = Number(
    localStorage.getItem(P.LAST_OWID)
  );
  if (n = isNaN(n) ? null : n, H())
    return n;
  const e = window.location.href ?? "";
  try {
    const r = Number((t = e.match(/\/u\/[0-9]+/i)) == null ? void 0 : t[0].substring(3));
    return (isNaN(r) ? null : r) ?? n;
  } catch {
    return null;
  }
}, Te = (n, e, t) => n.replace(new RegExp(`/u/${e}`, "i"), `/u/${t}`), No = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getOwIdAtIndexFromLocalstorageLegacy: sr,
  getOwIdFromPath: cr,
  getOwIdFromPathLegacy: ir,
  getOwIdIndexFromLocalstorage: $e,
  getOwIdIndexFromPathLegacy: nt,
  setOwIdInURL: Te
}, Symbol.toStringTag, { value: "Module" })), pt = () => {
  const n = window.localStorage.getItem(P.AUTH);
  if (n)
    try {
      return JSON.parse(n);
    } catch {
      return null;
    }
  return null;
}, ft = () => {
  const n = window.localStorage.getItem(P.LEGACY_AUTH);
  if (n)
    try {
      const e = JSON.parse(n);
      return {
        accessToken: e.apiToken,
        refreshToken: e.refreshToken,
        tokenType: "bearer",
        expiresIn: e.expiresAt,
        scope: "read write"
      };
    } catch {
      return null;
    }
  return null;
}, Le = () => {
  localStorage.removeItem(P.AUTH), localStorage.removeItem(P.LEGACY_AUTH), localStorage.removeItem(P.LAST_OWID), localStorage.removeItem(P.LEGACY_OWIDS_ARRAY);
}, Co = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clearAuthTokenFromLocalstorage: Le,
  readAuthDataFromLocalstorage: pt,
  readAuthDataFromLocalstorageLegacy: ft
}, Symbol.toStringTag, { value: "Module" })), lr = () => {
  var e, t, r;
  const n = localStorage.getItem(P.LEGACY_INIT) ?? "{}";
  try {
    const s = JSON.parse(n);
    return {
      favicon: (s == null ? void 0 : s.smallLogoUrl) ?? "",
      helpURL: ((r = (t = (e = s == null ? void 0 : s.pages) == null ? void 0 : e.help_url) == null ? void 0 : t[0]) == null ? void 0 : r.url) ?? ""
    };
  } catch {
    return {
      favicon: "",
      helpURL: ""
    };
  }
}, ur = () => {
  const n = localStorage.getItem(P.INIT) ?? "{}";
  try {
    const e = JSON.parse(n);
    return {
      favicon: e == null ? void 0 : e.favicon,
      helpURL: e == null ? void 0 : e.helpURL
    };
  } catch {
    return {
      favicon: "",
      helpURL: ""
    };
  }
}, dr = (n) => {
  var t, r, s;
  const e = {
    favicon: (n == null ? void 0 : n.smallLogoUrl) ?? "",
    helpURL: ((s = (r = (t = n == null ? void 0 : n.pages) == null ? void 0 : t.help_url) == null ? void 0 : r[0]) == null ? void 0 : s.url) ?? ""
  };
  window.localStorage.setItem(P.INIT, JSON.stringify(e));
}, pr = (n) => {
  window.localStorage.setItem(
    P.LEGACY_INIT,
    JSON.stringify(n)
  );
}, Fo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  readInitDataFromLocalstorage: ur,
  readLegacyInitDataFromLocalstorage: lr,
  storeInitDataToLocalstorage: dr,
  storeInitDataToLocalstorageLegacy: pr
}, Symbol.toStringTag, { value: "Module" }));
let fr;
function Bt(n) {
  fr = n;
}
function Ue() {
  return fr || Q;
}
function gr(n) {
  n.interceptors.request.use((e) => ({
    ...e,
    meta: {
      startTime: Date.now()
    }
  })), n.interceptors.response.use((e) => {
    var t, r, s;
    if (e) {
      const i = Date.now(), c = ((r = (t = e == null ? void 0 : e.config) == null ? void 0 : t.meta) == null ? void 0 : r.startTime) ?? i, l = i - c;
      return {
        ...e,
        config: {
          ...e.config,
          meta: {
            startTime: c,
            ...((s = e == null ? void 0 : e.config) == null ? void 0 : s.meta) ?? {},
            endTime: i,
            latency: l
          }
        }
      };
    }
    return e;
  });
}
function Pn(n, e) {
  const t = new URL(qe.appUrl, e).toString();
  n.interceptors.response.use(
    (r) => r,
    (r) => {
      var s;
      return Q.isCancel(r) ? Promise.reject({
        response: {
          data: r
        }
      }) : (((s = r == null ? void 0 : r.response) == null ? void 0 : s.status) === 401 && (Le(), H() || window.location.replace(t)), Promise.reject(r));
    }
  );
}
const Ne = {
  keys: (n) => [n]
}, Tn = {
  keys: (n) => [n]
}, Un = {
  keys: (n) => [n]
}, Nn = async ({
  signal: n,
  queryKey: e,
  meta: t
}) => {
  var c;
  e[0];
  const { CancelToken: r } = Q, s = r.source();
  n == null || n.addEventListener("abort", () => {
    s.cancel("/v3/ua/init - Request cancelled");
  });
  const i = t == null ? void 0 : t.axiosInstance;
  try {
    const l = await i.get("/v3/ua/init", {
      cancelToken: s.token
    }), { data: d } = l.data;
    return d;
  } catch (l) {
    return Promise.reject((c = l == null ? void 0 : l.response) == null ? void 0 : c.data);
  }
}, Cn = async ({
  queryKey: n,
  signal: e,
  meta: t
}) => {
  var c;
  n[0];
  const { CancelToken: r } = Q, s = r.source();
  e == null || e.addEventListener("abort", () => {
    s.cancel("/v3/ua/st/chatbot - Request cancelled");
  });
  const i = t == null ? void 0 : t.axiosInstance;
  try {
    const l = await i.get("/v3/ua/st/chatbot", {
      cancelToken: s.token
    }), { data: d } = l.data;
    return d;
  } catch (l) {
    return Promise.reject((c = l == null ? void 0 : l.response) == null ? void 0 : c.data);
  }
}, Fn = async ({
  queryKey: n,
  signal: e,
  pageParam: t = 1
}) => {
  var l;
  const { scope: r, ...s } = n[0], { CancelToken: i } = Q, c = i.source();
  e == null || e.addEventListener("abort", () => {
    c.cancel("/v3/ua/user/allowed-organizations - Request cancelled");
  });
  try {
    const d = await Ue().get("/v3/ua/user/allowed-organizations", {
      params: {
        ...s,
        pageNo: t
      },
      cancelToken: c.token
    }), { data: m } = d.data;
    return m ?? [];
  } catch (d) {
    return Promise.reject((l = d == null ? void 0 : d.response) == null ? void 0 : l.data);
  }
}, zn = (n) => {
  const e = {
    appId: -1,
    // need to get actual appId
    appName: "Marketplace",
    appIcon: "logo/marketplace.png",
    appUrl: "/marketplace",
    showInDrawer: !1
  }, t = {
    appId: -2,
    appName: "Messages",
    appIcon: "logo/messages.png",
    appUrl: "/messages",
    showInDrawer: !1
  };
  return Array.isArray(n) ? [...n.map((s) => ({ ...s, showInDrawer: !0 })), e, t, qe] : [e, t, qe];
}, Bn = async ({
  queryKey: n,
  signal: e
}) => {
  var s;
  n[0];
  const { CancelToken: t } = Q, r = t.source();
  e == null || e.addEventListener("abort", () => {
    r.cancel("/v3/ua/profile - Request cancelled");
  });
  try {
    const i = await Ue().get("/v3/ua/profile", {
      cancelToken: r.token
    }), { data: c } = i.data;
    return c;
  } catch (i) {
    return Promise.reject((s = i == null ? void 0 : i.response) == null ? void 0 : s.data);
  }
}, Wn = async ({
  queryKey: n,
  signal: e
}) => {
  var s;
  n[0];
  const { CancelToken: t } = Q, r = t.source();
  e == null || e.addEventListener("abort", () => {
    r.cancel("/v3/ua/chatbot - Request cancelled");
  });
  try {
    const i = await Ue().get("/v3/ua/chatbot", {
      cancelToken: r.token
    }), { data: c } = i.data;
    return c;
  } catch (i) {
    return Promise.reject((s = i == null ? void 0 : i.response) == null ? void 0 : s.data);
  }
}, Mn = async ({
  queryKey: n,
  signal: e
}) => {
  var s;
  n[0];
  const { CancelToken: t } = Q, r = t.source();
  e == null || e.addEventListener("abort", () => {
    r.cancel("/v3/ua/user/allowed-applications - Request cancelled");
  });
  try {
    const i = await Ue().get("/v3/ua/user/allowed-applications", {
      cancelToken: r.token
    }), { data: c } = i.data;
    return zn(c ?? []);
  } catch (i) {
    return Promise.reject((s = i == null ? void 0 : i.response) == null ? void 0 : s.data);
  }
}, Vn = async ({
  queryKey: n,
  signal: e
}) => {
  try {
    const { loggedInOwId: t } = n[0], { CancelToken: r } = Q, s = r.source();
    e == null || e.addEventListener("abort", () => {
      s.cancel(
        `/v3/ua/customer/config/${t} - Request cancelled`
      );
    });
    const i = await Ue().get(`/v3/ua/customer/config/${t}`, {
      cancelToken: s.token
    }), { data: c } = i.data;
    return c ?? {};
  } catch (t) {
    return Promise.reject((t == null ? void 0 : t.response) || t);
  }
}, $n = async () => {
  var n;
  try {
    const e = await Ue().post("/v3/ua/logout"), { data: t } = e.data;
    return t;
  } catch (e) {
    return Promise.reject((n = e == null ? void 0 : e.response) == null ? void 0 : n.data);
  }
}, Yn = async (n, e, t) => {
  var r;
  try {
    const s = new URL("/api", n), c = await Q.create({
      baseURL: s.toString(),
      headers: {
        Authorization: `Bearer ${e}`
      },
      signal: t
    }).get("/validate-user"), { message: l } = c.data;
    return l;
  } catch (s) {
    return t.aborted ? Promise.reject(s) : Promise.reject((r = s == null ? void 0 : s.response) == null ? void 0 : r.data);
  }
}, Hn = async (n, e, t) => {
  var r;
  try {
    const s = new URL("/api", n), i = Q.create({
      baseURL: s.toString(),
      headers: {
        "Content-Type": void 0,
        Authorization: At
      },
      signal: t
    }), c = new URLSearchParams();
    c.append("grant_type", "refresh_token"), c.append("refresh_token", e);
    const d = (await i.post("/v3/ua/oauth/token", c)).data ?? {};
    if (d.access_token && d.refresh_token)
      return d;
    throw new an("refresh token not valid");
  } catch (s) {
    return t.aborted ? Promise.reject(s) : Promise.reject((r = s == null ? void 0 : s.response) == null ? void 0 : r.data);
  }
}, qn = async ({
  queryKey: n,
  signal: e,
  meta: t
}) => {
  var i, c;
  n[0];
  const { CancelToken: r } = Q, s = r.source();
  e == null || e.addEventListener("abort", () => {
    s.cancel("/v3/ua/profile - Request cancelled");
  });
  try {
    const l = await ((i = t == null ? void 0 : t.instance) == null ? void 0 : i.get("/v3/ua/profile", {
      cancelToken: s.token
    })), { data: d } = l.data;
    return d;
  } catch (l) {
    return Promise.reject((c = l == null ? void 0 : l.response) == null ? void 0 : c.data);
  }
};
var gt = { exports: {} }, Be = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wt;
function Gn() {
  if (Wt)
    return Be;
  Wt = 1;
  var n = Yt, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(l, d, m) {
    var h, g = {}, y = null, _ = null;
    m !== void 0 && (y = "" + m), d.key !== void 0 && (y = "" + d.key), d.ref !== void 0 && (_ = d.ref);
    for (h in d)
      r.call(d, h) && !i.hasOwnProperty(h) && (g[h] = d[h]);
    if (l && l.defaultProps)
      for (h in d = l.defaultProps, d)
        g[h] === void 0 && (g[h] = d[h]);
    return { $$typeof: e, type: l, key: y, ref: _, props: g, _owner: s.current };
  }
  return Be.Fragment = t, Be.jsx = c, Be.jsxs = c, Be;
}
var We = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mt;
function Jn() {
  return Mt || (Mt = 1, process.env.NODE_ENV !== "production" && function() {
    var n = Yt, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), D = Symbol.iterator, w = "@@iterator";
    function T(a) {
      if (a === null || typeof a != "object")
        return null;
      var u = D && a[D] || a[w];
      return typeof u == "function" ? u : null;
    }
    var L = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(a) {
      {
        for (var u = arguments.length, f = new Array(u > 1 ? u - 1 : 0), I = 1; I < u; I++)
          f[I - 1] = arguments[I];
        O("error", a, f);
      }
    }
    function O(a, u, f) {
      {
        var I = L.ReactDebugCurrentFrame, k = I.getStackAddendum();
        k !== "" && (u += "%s", f = f.concat([k]));
        var N = f.map(function(R) {
          return String(R);
        });
        N.unshift("Warning: " + u), Function.prototype.apply.call(console[a], console, N);
      }
    }
    var E = !1, A = !1, U = !1, B = !1, Z = !1, ne;
    ne = Symbol.for("react.module.reference");
    function de(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === r || a === i || Z || a === s || a === m || a === h || B || a === _ || E || A || U || typeof a == "object" && a !== null && (a.$$typeof === y || a.$$typeof === g || a.$$typeof === c || a.$$typeof === l || a.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === ne || a.getModuleId !== void 0));
    }
    function pe(a, u, f) {
      var I = a.displayName;
      if (I)
        return I;
      var k = u.displayName || u.name || "";
      return k !== "" ? f + "(" + k + ")" : f;
    }
    function me(a) {
      return a.displayName || "Context";
    }
    function q(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case r:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case m:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case l:
            var u = a;
            return me(u) + ".Consumer";
          case c:
            var f = a;
            return me(f._context) + ".Provider";
          case d:
            return pe(a, a.render, "ForwardRef");
          case g:
            var I = a.displayName || null;
            return I !== null ? I : q(a.type) || "Memo";
          case y: {
            var k = a, N = k._payload, R = k._init;
            try {
              return q(R(N));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ee = Object.assign, ae = 0, we, F, S, $, oe, Y, se;
    function z() {
    }
    z.__reactDisabledLog = !0;
    function j() {
      {
        if (ae === 0) {
          we = console.log, F = console.info, S = console.warn, $ = console.error, oe = console.group, Y = console.groupCollapsed, se = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: z,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        ae++;
      }
    }
    function De() {
      {
        if (ae--, ae === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ee({}, a, {
              value: we
            }),
            info: ee({}, a, {
              value: F
            }),
            warn: ee({}, a, {
              value: S
            }),
            error: ee({}, a, {
              value: $
            }),
            group: ee({}, a, {
              value: oe
            }),
            groupCollapsed: ee({}, a, {
              value: Y
            }),
            groupEnd: ee({}, a, {
              value: se
            })
          });
        }
        ae < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var be = L.ReactCurrentDispatcher, _e;
    function ie(a, u, f) {
      {
        if (_e === void 0)
          try {
            throw Error();
          } catch (k) {
            var I = k.stack.trim().match(/\n( *(at )?)/);
            _e = I && I[1] || "";
          }
        return `
` + _e + a;
      }
    }
    var le = !1, ue;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      ue = new Je();
    }
    function Ce(a, u) {
      if (!a || le)
        return "";
      {
        var f = ue.get(a);
        if (f !== void 0)
          return f;
      }
      var I;
      le = !0;
      var k = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var N;
      N = be.current, be.current = null, j();
      try {
        if (u) {
          var R = function() {
            throw Error();
          };
          if (Object.defineProperty(R.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(R, []);
            } catch (X) {
              I = X;
            }
            Reflect.construct(a, [], R);
          } else {
            try {
              R.call();
            } catch (X) {
              I = X;
            }
            a.call(R.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (X) {
            I = X;
          }
          a();
        }
      } catch (X) {
        if (X && I && typeof X.stack == "string") {
          for (var b = X.stack.split(`
`), K = I.stack.split(`
`), W = b.length - 1, V = K.length - 1; W >= 1 && V >= 0 && b[W] !== K[V]; )
            V--;
          for (; W >= 1 && V >= 0; W--, V--)
            if (b[W] !== K[V]) {
              if (W !== 1 || V !== 1)
                do
                  if (W--, V--, V < 0 || b[W] !== K[V]) {
                    var re = `
` + b[W].replace(" at new ", " at ");
                    return a.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", a.displayName)), typeof a == "function" && ue.set(a, re), re;
                  }
                while (W >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        le = !1, be.current = N, De(), Error.prepareStackTrace = k;
      }
      var je = a ? a.displayName || a.name : "", Ae = je ? ie(je) : "";
      return typeof a == "function" && ue.set(a, Ae), Ae;
    }
    function Ke(a, u, f) {
      return Ce(a, !1);
    }
    function Qe(a) {
      var u = a.prototype;
      return !!(u && u.isReactComponent);
    }
    function Re(a, u, f) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return Ce(a, Qe(a));
      if (typeof a == "string")
        return ie(a);
      switch (a) {
        case m:
          return ie("Suspense");
        case h:
          return ie("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case d:
            return Ke(a.render);
          case g:
            return Re(a.type, u, f);
          case y: {
            var I = a, k = I._payload, N = I._init;
            try {
              return Re(N(k), u, f);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, Xe = {}, Ze = L.ReactDebugCurrentFrame;
    function fe(a) {
      if (a) {
        var u = a._owner, f = Re(a.type, a._source, u ? u.type : null);
        Ze.setExtraStackFrame(f);
      } else
        Ze.setExtraStackFrame(null);
    }
    function et(a, u, f, I, k) {
      {
        var N = Function.call.bind(ye);
        for (var R in a)
          if (N(a, R)) {
            var b = void 0;
            try {
              if (typeof a[R] != "function") {
                var K = Error((I || "React class") + ": " + f + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw K.name = "Invariant Violation", K;
              }
              b = a[R](u, R, I, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              b = W;
            }
            b && !(b instanceof Error) && (fe(k), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", I || "React class", f, R, typeof b), fe(null)), b instanceof Error && !(b.message in Xe) && (Xe[b.message] = !0, fe(k), x("Failed %s type: %s", f, b.message), fe(null));
          }
      }
    }
    var Lr = Array.isArray;
    function ot(a) {
      return Lr(a);
    }
    function xr(a) {
      {
        var u = typeof Symbol == "function" && Symbol.toStringTag, f = u && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return f;
      }
    }
    function Er(a) {
      try {
        return Et(a), !1;
      } catch {
        return !0;
      }
    }
    function Et(a) {
      return "" + a;
    }
    function kt(a) {
      if (Er(a))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", xr(a)), Et(a);
    }
    var Fe = L.ReactCurrentOwner, kr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Dt, Ot, st;
    st = {};
    function Dr(a) {
      if (ye.call(a, "ref")) {
        var u = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function Or(a) {
      if (ye.call(a, "key")) {
        var u = Object.getOwnPropertyDescriptor(a, "key").get;
        if (u && u.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function jr(a, u) {
      if (typeof a.ref == "string" && Fe.current && u && Fe.current.stateNode !== u) {
        var f = q(Fe.current.type);
        st[f] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', q(Fe.current.type), a.ref), st[f] = !0);
      }
    }
    function Pr(a, u) {
      {
        var f = function() {
          Dt || (Dt = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function Tr(a, u) {
      {
        var f = function() {
          Ot || (Ot = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u));
        };
        f.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var Ur = function(a, u, f, I, k, N, R) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: a,
        key: u,
        ref: f,
        props: R,
        // Record the component responsible for creating this element.
        _owner: N
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: I
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function Nr(a, u, f, I, k) {
      {
        var N, R = {}, b = null, K = null;
        f !== void 0 && (kt(f), b = "" + f), Or(u) && (kt(u.key), b = "" + u.key), Dr(u) && (K = u.ref, jr(u, k));
        for (N in u)
          ye.call(u, N) && !kr.hasOwnProperty(N) && (R[N] = u[N]);
        if (a && a.defaultProps) {
          var W = a.defaultProps;
          for (N in W)
            R[N] === void 0 && (R[N] = W[N]);
        }
        if (b || K) {
          var V = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          b && Pr(R, V), K && Tr(R, V);
        }
        return Ur(a, b, K, k, I, Fe.current, R);
      }
    }
    var it = L.ReactCurrentOwner, jt = L.ReactDebugCurrentFrame;
    function Oe(a) {
      if (a) {
        var u = a._owner, f = Re(a.type, a._source, u ? u.type : null);
        jt.setExtraStackFrame(f);
      } else
        jt.setExtraStackFrame(null);
    }
    var ct;
    ct = !1;
    function lt(a) {
      return typeof a == "object" && a !== null && a.$$typeof === e;
    }
    function Pt() {
      {
        if (it.current) {
          var a = q(it.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function Cr(a) {
      {
        if (a !== void 0) {
          var u = a.fileName.replace(/^.*[\\\/]/, ""), f = a.lineNumber;
          return `

Check your code at ` + u + ":" + f + ".";
        }
        return "";
      }
    }
    var Tt = {};
    function Fr(a) {
      {
        var u = Pt();
        if (!u) {
          var f = typeof a == "string" ? a : a.displayName || a.name;
          f && (u = `

Check the top-level render call using <` + f + ">.");
        }
        return u;
      }
    }
    function Ut(a, u) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var f = Fr(u);
        if (Tt[f])
          return;
        Tt[f] = !0;
        var I = "";
        a && a._owner && a._owner !== it.current && (I = " It was passed a child from " + q(a._owner.type) + "."), Oe(a), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, I), Oe(null);
      }
    }
    function Nt(a, u) {
      {
        if (typeof a != "object")
          return;
        if (ot(a))
          for (var f = 0; f < a.length; f++) {
            var I = a[f];
            lt(I) && Ut(I, u);
          }
        else if (lt(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var k = T(a);
          if (typeof k == "function" && k !== a.entries)
            for (var N = k.call(a), R; !(R = N.next()).done; )
              lt(R.value) && Ut(R.value, u);
        }
      }
    }
    function zr(a) {
      {
        var u = a.type;
        if (u == null || typeof u == "string")
          return;
        var f;
        if (typeof u == "function")
          f = u.propTypes;
        else if (typeof u == "object" && (u.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        u.$$typeof === g))
          f = u.propTypes;
        else
          return;
        if (f) {
          var I = q(u);
          et(f, a.props, "prop", I, a);
        } else if (u.PropTypes !== void 0 && !ct) {
          ct = !0;
          var k = q(u);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", k || "Unknown");
        }
        typeof u.getDefaultProps == "function" && !u.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Br(a) {
      {
        for (var u = Object.keys(a.props), f = 0; f < u.length; f++) {
          var I = u[f];
          if (I !== "children" && I !== "key") {
            Oe(a), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", I), Oe(null);
            break;
          }
        }
        a.ref !== null && (Oe(a), x("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var Ct = {};
    function Ft(a, u, f, I, k, N) {
      {
        var R = de(a);
        if (!R) {
          var b = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var K = Cr(k);
          K ? b += K : b += Pt();
          var W;
          a === null ? W = "null" : ot(a) ? W = "array" : a !== void 0 && a.$$typeof === e ? (W = "<" + (q(a.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : W = typeof a, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, b);
        }
        var V = Nr(a, u, f, k, N);
        if (V == null)
          return V;
        if (R) {
          var re = u.children;
          if (re !== void 0)
            if (I)
              if (ot(re)) {
                for (var je = 0; je < re.length; je++)
                  Nt(re[je], a);
                Object.freeze && Object.freeze(re);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nt(re, a);
        }
        if (ye.call(u, "key")) {
          var Ae = q(a), X = Object.keys(u).filter(function(Hr) {
            return Hr !== "key";
          }), ut = X.length > 0 ? "{key: someKey, " + X.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ct[Ae + ut]) {
            var Yr = X.length > 0 ? "{" + X.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ut, Ae, Yr, Ae), Ct[Ae + ut] = !0;
          }
        }
        return a === r ? Br(V) : zr(V), V;
      }
    }
    function Wr(a, u, f) {
      return Ft(a, u, f, !0);
    }
    function Mr(a, u, f) {
      return Ft(a, u, f, !1);
    }
    var Vr = Mr, $r = Wr;
    We.Fragment = r, We.jsx = Vr, We.jsxs = $r;
  }()), We;
}
process.env.NODE_ENV === "production" ? gt.exports = Gn() : gt.exports = Jn();
var o = gt.exports;
class Kn {
  constructor(e) {
    v(this, "originURLFallback");
    v(this, "legacyMode");
    v(this, "deploymentEnvironment");
    this.originURLFallback = e.originURLFallback, this.legacyMode = e.legacyMode, this.deploymentEnvironment = e.deploymentEnvironment;
  }
  get originURL() {
    return _t(this.originURLFallback);
  }
  get owIdHeaderKey() {
    return nr;
  }
  get OwIdFromPath() {
    return this.legacyMode ? ir() : cr();
  }
  get svgHostURL() {
    return this.deploymentEnvironment === "prod" ? ar : or;
  }
}
const hr = p.createContext(
  null
), Ge = () => p.useContext(hr), zo = (n) => {
  const {
    originURLFallback: e,
    legacyMode: t = !0,
    disableRedirectWhenWorkspaceIsSuspended: r = !1
  } = n, { children: s, ...i } = n, [c, l] = p.useState(null), d = { ...i, disableRedirectWhenWorkspaceIsSuspended: r }, m = i.deploymentEnvironment;
  return p.useEffect(() => {
    const h = new Kn({
      originURLFallback: e,
      legacyMode: t,
      deploymentEnvironment: m
    });
    l(h);
  }, [e, t, m]), c && /* @__PURE__ */ o.jsx(
    hr.Provider,
    {
      value: {
        rootProps: d,
        instance: c
      },
      children: s
    }
  );
};
class ht {
  constructor(e) {
    v(this, "userConfig");
    v(this, "secret");
    v(this, "initDatadog", (e, t) => {
      var r, s;
      if ((r = this == null ? void 0 : this.secret) != null && r.applicationId && ((s = this == null ? void 0 : this.secret) != null && s.clientToken)) {
        const i = {
          trackUserInteractions: !0,
          traceSampleRate: 100,
          trackViewsManually: !0,
          // allowedTracingUrls: [originURL],
          ...e,
          // cannot override these parameters
          ...this.secret,
          site: "datadoghq.com",
          service: this.userConfig.appName,
          version: this.userConfig.appVersion,
          env: this.userConfig.env
        };
        if (ze.init(i), i.trackViewsManually)
          try {
            ze.startView(window.location.pathname);
          } catch (c) {
            console.error(c);
          }
      }
    });
    v(this, "setUser", (e) => {
      ze.setUser({
        id: `${e.owId}`,
        name: e.userName,
        email: e.userEmail,
        organization: e.organizationName,
        customer_id: `${e.owId}`,
        user_email: e.userEmail
      });
    });
    this.userConfig = e, this.secret = {
      applicationId: e.applicationId,
      clientToken: e.clientToken
    };
  }
  getDatadogInstance() {
    return ze;
  }
}
v(ht, "onReady", (e) => {
  ze.onReady(e);
});
const mr = p.createContext(null), wr = () => p.useContext(mr);
class Qn {
  constructor(e) {
    v(this, "originURLFallback");
    v(this, "deploymentEnvironment");
    this.originURLFallback = e.originURLFallback, this.deploymentEnvironment = e.deploymentEnvironment;
  }
  get originURL() {
    return _t(this.originURLFallback);
  }
  get iqmPlatformBasicAuth() {
    return At;
  }
  get svgHostURL() {
    return this.deploymentEnvironment === "prod" ? ar : or;
  }
}
const yr = p.createContext(
  null
), Ir = () => p.useContext(yr), Bo = (n) => {
  const { originURLFallback: e, deploymentEnvironment: t } = n, { children: r, ...s } = n, [i, c] = p.useState(null), l = { ...s };
  return p.useEffect(() => {
    const d = new Qn({
      originURLFallback: e,
      deploymentEnvironment: t
    });
    c(d);
  }, [e, t]), i && /* @__PURE__ */ o.jsx(
    yr.Provider,
    {
      value: {
        rootProps: l,
        instance: i
      },
      children: r
    }
  );
}, Wo = (n) => {
  var x, O, E, A, U, B, Z, ne, de, pe, me, q, ee, ae, we, F, S, $;
  const { children: e } = n, t = Ge(), r = Ir(), [s, i] = p.useState(
    null
  ), [c, l] = p.useState(""), [d, m] = p.useState(!0), h = ((O = (x = t == null ? void 0 : t.rootProps) == null ? void 0 : x.dataDogCredentials) == null ? void 0 : O.applicationId) || ((A = (E = r == null ? void 0 : r.rootProps) == null ? void 0 : E.dataDogCredentials) == null ? void 0 : A.applicationId), g = ((B = (U = t == null ? void 0 : t.rootProps) == null ? void 0 : U.dataDogCredentials) == null ? void 0 : B.clientToken) || ((ne = (Z = r == null ? void 0 : r.rootProps) == null ? void 0 : Z.dataDogCredentials) == null ? void 0 : ne.clientToken), y = ((de = t == null ? void 0 : t.rootProps) == null ? void 0 : de.appName) || ((pe = r == null ? void 0 : r.rootProps) == null ? void 0 : pe.appName), _ = ((me = t == null ? void 0 : t.rootProps) == null ? void 0 : me.appVersion) || ((q = r == null ? void 0 : r.rootProps) == null ? void 0 : q.appVersion), D = ((ee = t == null ? void 0 : t.rootProps) == null ? void 0 : ee.deploymentEnvironment) || ((ae = r == null ? void 0 : r.rootProps) == null ? void 0 : ae.deploymentEnvironment), w = ((we = t == null ? void 0 : t.rootProps) == null ? void 0 : we.dataDogConfig) || ((F = r == null ? void 0 : r.rootProps) == null ? void 0 : F.dataDogConfig), T = ((S = t == null ? void 0 : t.instance) == null ? void 0 : S.originURL) || (($ = r == null ? void 0 : r.instance) == null ? void 0 : $.originURL), L = !t && !r;
  return p.useEffect(() => {
    ht.onReady(() => {
      if (L) {
        l(
          "DataDogProvider:Did you import the AppRootProvider or InitRootProvider context"
        ), m(!1);
        return;
      } else if (!h || !g) {
        l(
          "DataDogProvider: You have not pass credentials to datadog"
        ), m(!1);
        return;
      }
      const oe = new ht({
        clientToken: g,
        applicationId: h,
        appName: y ?? "",
        appVersion: _ ?? "",
        env: D ?? "stage"
      });
      oe.initDatadog(w ?? {}, T), i(oe), m(!1);
    });
  }, [
    L,
    h,
    g,
    y,
    _,
    D,
    w,
    T
  ]), d ? "initializing datadog" : c || /* @__PURE__ */ o.jsx(mr.Provider, { value: s, children: e });
}, Xn = {
  alignment: "right",
  horizontal_padding: 20,
  vertical_padding: 20,
  hide_default_launcher: !0
}, Vt = ({
  intercomId: n,
  settings: e = Xn
}) => {
  (function() {
    const t = window, r = t.Intercom;
    if (typeof r == "function")
      r("reattach_activator"), r("update", t.intercomSettings);
    else {
      const s = document, i = function(...l) {
        i.c(l);
      };
      i.q = [], i.c = function(l) {
        i.q.push(l);
      }, t.Intercom = i;
      const c = function() {
        const l = s.createElement("script");
        l.type = "text/javascript", l.async = !0, l.src = "https://widget.intercom.io/widget/" + n;
        const d = s.getElementsByTagName("script")[0];
        d.parentNode.insertBefore(l, d);
      };
      document.readyState === "complete" ? c() : t.attachEvent ? t.attachEvent("onload", c) : t.addEventListener("load", c, !1);
    }
  })(), window.intercomSettings = {
    app_id: n,
    ...e
  };
};
class $t {
  constructor(e) {
    v(this, "parmas");
    v(this, "bootIntercom", () => {
      try {
        window == null || window.Intercom("boot", {
          app_id: this.parmas.intercomId,
          ...this.parmas
        });
      } catch {
        process.env.NODE_ENV !== "production" && console.log("Error booting intercom");
      }
    });
    v(this, "shutdownIntercom", () => {
      var e;
      (e = window.Intercom) == null || e.call(window, "shutdown");
    });
    v(this, "onIntercomShow", (e) => {
      window == null || window.Intercom("onShow", e);
    });
    v(this, "onIntercomHide", (e) => {
      window == null || window.Intercom("onHide", e);
    });
    v(this, "hideIntercom", () => {
      var e;
      (e = window.Intercom) == null || e.call(window, "hide");
    });
    v(this, "showIntercom", () => {
      var e;
      (e = window.Intercom) == null || e.call(window, "show");
    });
    v(this, "onIntercomeUnreadCountChange", (e) => {
      window == null || window.Intercom("onUnreadCountChange", e);
    });
    this.parmas = e;
  }
}
const vr = p.createContext(null), Zn = () => p.useContext(vr), St = p.createContext({});
process.env.NODE_ENV !== "production" && (St.displayName = "InitContext");
const ea = () => p.useContext(St);
class ta {
  constructor(e) {
    v(this, "legacyMode");
    v(this, "initData");
    v(this, "intercomId");
    v(this, "initRootInst");
    this.intercomId = e.intercomId, this.legacyMode = e.legacyMode, this.initData = e.initData, this.initRootInst = e.initRootInst, this.legacyMode && pr(this.initData), dr(this.initData);
  }
  get favicon() {
    return this.initData.smallLogoUrl;
  }
  get showOrganizationName() {
    return this.initData.isIncludeOrganizationName;
  }
  get organizationName() {
    return this.initData.organizationName;
  }
  get organizationLogo() {
    return this.initData.largeLogoUrl;
  }
  get organizationID() {
    var e, t;
    return ((e = this.initData) == null ? void 0 : e.orgId) || ((t = this.initData) == null ? void 0 : t.wsId);
  }
  get loggedInOwId() {
    return this.initData.owId;
  }
  get originURL() {
    return this.initRootInst.originURL;
  }
  get iqmPlatformBasicAuth() {
    return this.initRootInst.iqmPlatformBasicAuth;
  }
  get helpURL() {
    var e, t, r, s;
    return ((s = (r = (t = (e = this.initData) == null ? void 0 : e.pages) == null ? void 0 : t.help_url) == null ? void 0 : r[0]) == null ? void 0 : s.url) ?? "";
  }
  get headerLinks() {
    var e, t, r, s;
    return Array.isArray((t = (e = this.initData) == null ? void 0 : e.pages) == null ? void 0 : t.header) ? (s = (r = this.initData) == null ? void 0 : r.pages) == null ? void 0 : s.header : [];
  }
  get footerLinks() {
    var e, t, r, s;
    return Array.isArray((t = (e = this.initData) == null ? void 0 : e.pages) == null ? void 0 : t.footer) ? (s = (r = this.initData) == null ? void 0 : r.pages) == null ? void 0 : s.footer : [];
  }
  get landingPageImage() {
    var e, t, r;
    return ((r = (t = (e = this.initData) == null ? void 0 : e.pages) == null ? void 0 : t.landingPages) == null ? void 0 : r[0]) ?? "";
  }
  get organizationType() {
    var e;
    return (e = this.initData) != null && e.ihpOwner ? ce.SUPER : ce.WORKSPACE;
  }
  get passwordNote() {
    return this.initData.passwordNote;
  }
  get workspaceURLSuffix() {
    return this.initData.workspaceURLSuffix;
  }
  get owId() {
    return this.initData.owId;
  }
  get svgHostURL() {
    return this.initRootInst.svgHostURL;
  }
}
const ra = (n, e) => {
  const t = new URL("/api", n.originURL), r = Q.create({
    baseURL: t.toString()
  });
  return gr(r), e == null || e(r), r;
}, Mo = (n) => {
  var O;
  const { children: e } = n, t = Ir(), [r, s] = p.useState(!0), [i, c] = p.useState(""), [l, d] = p.useState(null), [m, h] = p.useState(
    null
  ), [g, y] = p.useState(!1);
  p.useEffect(() => {
    var A;
    if (!t) {
      s(!1), c(
        "InitProvider:Did you import the InitRootProvider context"
      ), y(!0);
      return;
    }
    const E = ra(
      {
        originURL: ((A = t == null ? void 0 : t.instance) == null ? void 0 : A.originURL) ?? ""
      },
      (U) => {
        var B, Z;
        (Z = (B = t == null ? void 0 : t.rootProps) == null ? void 0 : B.attachInterceptorsToInstance) == null || Z.call(B, U);
      }
    );
    h(() => E);
  }, [t]);
  const _ = fa(m, {
    enabled: m !== null
  }), D = ga(m, {
    enabled: m !== null
  }), w = _.isFetching || D.isFetching || _.isLoading || D.isLoading, T = _.isError || D.isError;
  p.useEffect(() => {
    if (!w) {
      if (T) {
        s(!1), c("Error loading data"), y(!0), process.env.NODE_ENV !== "production" && (_.isError && console.error(_.error), D.isError && console.error(D.error));
        return;
      }
      if (_.data && D.data) {
        const E = new ta({
          initData: _.data,
          initRootInst: t.instance,
          intercomId: D.data.chatbotAppId,
          legacyMode: t.rootProps.legacyMode ?? !0
        });
        d(E), s(!1);
        return;
      }
      c("Error occured while loading app init data"), s(!1), y(!0);
    }
  }, [
    w,
    T,
    _.data,
    D.data,
    _.error,
    D.error,
    _.isError,
    D.isError,
    m,
    t
  ]);
  const L = H() ? "App Initialzing..." : null, x = H() ? i : g ? "Error Loading App" : null;
  return /* @__PURE__ */ o.jsx(
    St.Provider,
    {
      value: {
        initMeta: l,
        apiInstance: m
      },
      children: r ? L : i !== "" ? x : /* @__PURE__ */ o.jsx(
        br,
        {
          enableIntercom: (O = t == null ? void 0 : t.rootProps) == null ? void 0 : O.enableIntercom,
          children: e
        }
      )
    }
  );
}, br = (n) => {
  const { enableIntercom: e = !0, children: t } = n, { appMeta: r } = ve(), { initMeta: s } = ea(), [i, c] = p.useState(null);
  return p.useEffect(() => {
    let l;
    if (e && (r != null && r.intercomId))
      return Vt({ intercomId: r.intercomId }), l = new $t({
        email: r == null ? void 0 : r.userEmail,
        intercomId: r == null ? void 0 : r.intercomId,
        name: r == null ? void 0 : r.userDisplayName,
        owId: r == null ? void 0 : r.loggedInOwId
      }), l && (l.bootIntercom(), l.hideIntercom()), c(l), () => {
        l == null || l.shutdownIntercom();
      };
  }, [
    e,
    r == null ? void 0 : r.userEmail,
    r == null ? void 0 : r.intercomId,
    r == null ? void 0 : r.userDisplayName,
    r == null ? void 0 : r.loggedInOwId
  ]), p.useEffect(() => {
    let l;
    if (e && (s != null && s.intercomId))
      return Vt({ intercomId: s.intercomId }), l = new $t({
        intercomId: s.intercomId
      }), l && l.bootIntercom(), c(l), () => {
        l == null || l.shutdownIntercom();
      };
  }, [e, s == null ? void 0 : s.intercomId]), /* @__PURE__ */ o.jsx(vr.Provider, { value: i, children: t });
}, Lt = p.createContext({});
process.env.NODE_ENV !== "production" && (Lt.displayName = "AppContext");
const ve = () => p.useContext(Lt);
class na {
  constructor(e) {
    v(this, "authData");
    v(this, "profileData");
    v(this, "orgsHirerachy");
    v(this, "currentApp");
    v(this, "appRootInst");
    v(this, "legacyMode");
    v(this, "useNewCrossLoginURL");
    v(this, "initData");
    v(this, "allowedApps");
    v(this, "customerConfigData");
    v(this, "intercomId");
    v(this, "refetchFunction");
    /**
     * @deprecated
     * @returns string
     */
    v(this, "prepareAppSwitchingURLLegacy", (e, t) => {
      const [r] = $e(this.loggedInOwId), s = new URL(
        `${e.appUrl}/u/${r}/`,
        this.originURL
      );
      return s.hash = t, s.toString();
    });
    v(this, "prepareAppSwitchingURLNew", (e, t) => {
      const r = new URL(
        `${e.appUrl}/u/${this.loggedInOwId}/`,
        this.originURL
      );
      return r.hash = t, r.toString();
    });
    v(this, "prepareAppSwitchingURL", (e, t = "") => this.legacyMode ? this.prepareAppSwitchingURLLegacy(e, t) : this.prepareAppSwitchingURLNew(e, t));
    /**
     *
     * @depricated
     * @return string
     */
    v(this, "prepareOrganizationSwitchingURLLegacy", (e) => {
      if (e.owId === this.loggedInOwId)
        return window.location.href;
      if (window.location.href.includes(e.workspaceDomain)) {
        const [r, s] = $e(e.owId), i = nt();
        if (r === -1 && i >= 0) {
          const c = [...s, e.owId];
          return localStorage.setItem(
            P.LEGACY_OWIDS_ARRAY,
            JSON.stringify(c)
          ), Te(
            window.location.href,
            i,
            c.length - 1
          ).replace(window.location.hash, "");
        } else if (r >= 0 && i >= 0)
          return Te(
            window.location.href,
            i,
            r
          ).replace(window.location.hash, "");
        return window.location.href;
      } else {
        const r = new URLSearchParams();
        return r.set("ow", `${e.owId}`), r.set("apiToken", btoa(this.authToken)), r.set("refreshToken", btoa(this.refreshToken)), r.set("expiresAt", `${this.authTokenExpiryInMilliseconds / 1e3}`), r.set("redirect_to", this.currentApp), `https://${e.workspaceDomain}/#/login?${r.toString()}`;
      }
    });
    /**
     *
     * @depricated
     * @return string
     */
    v(this, "prepareOrganizationSwitchingURLLegacyWithNewCrossLogin", (e) => {
      var r, s;
      if (e.owId === this.loggedInOwId)
        return window.location.href;
      if (window.location.href.includes(e.workspaceDomain)) {
        const [i, c] = $e(e.owId), l = nt();
        if (i === -1 && l >= 0) {
          const d = [...c, e.owId];
          return localStorage.setItem(
            P.LEGACY_OWIDS_ARRAY,
            JSON.stringify(d)
          ), Te(
            window.location.href,
            l,
            d.length - 1
          ).replace(window.location.hash, "");
        } else if (i >= 0 && l >= 0)
          return Te(
            window.location.href,
            l,
            i
          ).replace(window.location.hash, "");
        return window.location.href;
      } else {
        const i = ((s = (r = this.allowedApps) == null ? void 0 : r[this.currentApp]) == null ? void 0 : s.appUrl) ?? "", c = {
          ...this.authData,
          refreshToken: btoa(this.authData.refreshToken),
          accessToken: btoa(this.authData.accessToken),
          owId: e.owId,
          redirectAppName: i
        }, l = new URLSearchParams(
          c
        );
        return `https://${e.workspaceDomain}/#/cross-login?${l.toString()}`;
      }
    });
    v(this, "prepareOrganizationSwitchingURLNew", (e) => {
      var r, s;
      if (e.owId === this.loggedInOwId)
        return window.location.href;
      if (window.location.href.includes(e.workspaceDomain))
        return Te(
          window.location.href,
          this.loggedInOwId,
          e.owId
        ).replace(window.location.hash, "");
      {
        const i = ((s = (r = this.allowedApps) == null ? void 0 : r[this.currentApp]) == null ? void 0 : s.appUrl) ?? "", c = {
          ...this.authData,
          refreshToken: btoa(this.authData.refreshToken),
          accessToken: btoa(this.authData.accessToken),
          owId: e.owId,
          redirectAppName: i
        }, l = new URLSearchParams(
          c
        );
        return `https://${e.workspaceDomain}/#/cross-login?${l}`;
      }
    });
    v(this, "prepareOrganizationSwitchingURL", (e) => this.legacyMode ? this.useNewCrossLoginURL ? this.prepareOrganizationSwitchingURLLegacyWithNewCrossLogin(
      e
    ) : this.prepareOrganizationSwitchingURLLegacy(e) : this.prepareOrganizationSwitchingURLNew(e));
    this.intercomId = e.intercomId, this.currentApp = e.currentApp, this.appRootInst = e.appRootInst, this.legacyMode = e.legacyMode, this.useNewCrossLoginURL = e.useNewCrossLoginURL, this.allowedApps = aa(e.allowedApps), this.refetchFunction = e.refetchQueries, this.authData = e.authData, this.profileData = e.profileData, this.customerConfigData = e.customerConfigData;
    const t = {
      organizationName: this.profileData.organizationName,
      owId: this.profileData.owId,
      // todo - figure out a way to get this data from init
      workspaceDomain: window.location.host,
      isAccess: !1
    };
    this.orgsHirerachy = [
      ..._r(this.profileData.parentOrganization),
      t
    ], this.initData = this.legacyMode ? lr() : ur();
  }
  get favicon() {
    return this.initData.favicon;
  }
  get appHelpURL() {
    return this.initData.helpURL ?? "";
  }
  get userEmail() {
    return this.profileData.email ?? "";
  }
  get userAvatar() {
    return this.profileData.userAvatar;
  }
  get isUserOrganizationOwner() {
    return this.profileData.isOwnerUser;
  }
  get userDisplayName() {
    return this.profileData.displayName ?? "";
  }
  get userFirstName() {
    return this.profileData.firstName ?? "";
  }
  get userLastName() {
    return this.profileData.lastName ?? "";
  }
  get isBetaUser() {
    return this.profileData.isBetaUser;
  }
  get organizationName() {
    return this.profileData.organizationName ?? "";
  }
  get organizationLogo() {
    return this.profileData.organizationLogo;
  }
  get organizationTimezone() {
    return this.profileData.organizationTimezone;
  }
  get organizationType() {
    return this.profileData.isPlatformOwnerOrg ? ce.SUPER : this.profileData.isWorkspaceOwnerOrg ? ce.WORKSPACE : ce.ADVERTISER;
  }
  get isInfobarEnabled() {
    return this.organizationType === "SUPER" || this.organizationType === "WORKSPACE" ? !0 : this.organizationType === "ADVERTISER" && this.profileData.parentOrganization;
  }
  get loggedInOwId() {
    return this.profileData.owId;
  }
  get organizationHirerachy() {
    return this.orgsHirerachy;
  }
  get authToken() {
    return this.authData.accessToken;
  }
  get authTokenExpiryInMilliseconds() {
    return this.authData.expiresIn * 1e3;
  }
  get refreshToken() {
    return this.authData.refreshToken;
  }
  get originURL() {
    return this.appRootInst.originURL;
  }
  get owIdHeaderKey() {
    return this.appRootInst.owIdHeaderKey;
  }
  get isOnlyImpressionBasedCustomer() {
    return this.profileData.isOnlyImpressionBasedCustomer ?? !1;
  }
  get isWorkspaceSuspended() {
    var e, t;
    return ((t = (e = this.profileData) == null ? void 0 : e.failureDetails) == null ? void 0 : t.status) === "SUSPENDED";
  }
  get workspaceSuspendedReason() {
    var e, t, r, s;
    if (this.isWorkspaceSuspended)
      return {
        reason: ((t = (e = this.profileData) == null ? void 0 : e.failureDetails) == null ? void 0 : t.reason) ?? "",
        supportEmail: ((s = (r = this.profileData) == null ? void 0 : r.failureDetails) == null ? void 0 : s.supportEmail) ?? ""
      };
  }
  get bidModelingCondition() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.bidModel) ?? jn;
  }
  get isVldEnable() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.isVldEnabled) ?? !1;
  }
  get isBidShadingEnabled() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.isBidShadingEnabled) ?? !0;
  }
  get hadVldGenerated() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.hadVldGenerated) ?? !1;
  }
  get isPldEnable() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.isPldEnabled) ?? !1;
  }
  get hadPldGenerated() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.hadPldGenerated) ?? !1;
  }
  get isSlsEnable() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.isSlsEnabled) ?? !1;
  }
  get hadSlsGenerated() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.hadSlsGenerated) ?? !1;
  }
  get slsRateForDiscount() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.slsRateForDiscount) ?? 0;
  }
  get slsMarkupPercentageForDiscount() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.slsMarkupPercentageForDiscount) ?? 0;
  }
  get pldMarkupTypeId() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.pldMarkupTypeId) ?? NaN;
  }
  get pldMarkupValue() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.pldMarkupValue) ?? 0;
  }
  get pldRateForDiscount() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.pldRateForDiscount) ?? 0;
  }
  get pldMarkupPercentageForDiscount() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.pldMarkupPercentageForDiscount) ?? 0;
  }
  get vertical() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.vertical) ?? "political";
  }
  // This could be 1=absolute and 2=precentage
  get vldMarkupTypeId() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.vldMarkupTypeId) ?? 1;
  }
  get vldMarkupValue() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.vldMarkupValue) ?? 0;
  }
  get pgCampaignFees() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.pgCampaignFees) ?? 0;
  }
  get pgWorkspaceShare() {
    var e;
    return ((e = this.customerConfigData) == null ? void 0 : e.pgWorkspaceShare) ?? 0;
  }
  getAppData(e) {
    return this.allowedApps[e];
  }
  refetchData(e) {
    var t;
    return (t = this == null ? void 0 : this.refetchFunction) == null ? void 0 : t.call(this, e);
  }
  logout() {
    Le();
    const e = new URL(
      qe.appUrl,
      this.appRootInst.originURL
    ).toString();
    window.location.href = H() ? window.location.href : e;
  }
}
const _r = (n) => {
  let e = [];
  if (n) {
    const { parentOrganization: t, ...r } = n;
    return t && (e = _r(t)), e.push(r), e;
  }
  return [];
}, aa = (n) => n.reduce(
  (e, t) => (e[t.appName] = t, e),
  {}
), oa = (n, e, t, r, s) => n ? sa(e, t, r, s) : ia(e, t, r, s), sa = (n, e, t, r) => {
  const [s] = $e(n), i = new URL(`${t.appUrl}/u/${s}/`, e);
  return i.hash = r, i.toString();
}, ia = (n, e, t, r) => {
  const s = new URL(`${t.appUrl}/u/${n}/`, e);
  return s.hash = r, s.toString();
}, mt = (n, e) => {
  const t = new URL("/api", n.originURL), r = Q.create({
    baseURL: t.toString(),
    headers: {
      authorization: `Bearer ${n.token}`,
      [n.owIdHeaderKey]: n.owId
    }
  });
  return Pn(r, n.originURL ?? ""), gr(r), e == null || e(r, n.token, n.owId), r;
}, Vo = (n) => {
  var me, q, ee, ae, we;
  const { children: e } = n, t = Ge(), r = wr(), s = (me = t == null ? void 0 : t.rootProps) == null ? void 0 : me.legacyMode, [i, c] = p.useState(!0), [l, d] = p.useState(""), [m, h] = p.useState(
    null
  ), [g, y] = p.useState(
    null
  ), [_, D] = p.useState(!1), [w, T] = p.useState(null), L = p.useMemo(() => {
    var S;
    const F = (S = t == null ? void 0 : t.instance) == null ? void 0 : S.originURL;
    return new URL(qe.appUrl, F).toString();
  }, [(q = t == null ? void 0 : t.instance) == null ? void 0 : q.originURL]), x = (ee = t == null ? void 0 : t.instance) == null ? void 0 : ee.originURL;
  p.useEffect(() => {
    var $, oe, Y;
    const F = new AbortController();
    if (!t) {
      c(!1), d(
        "AppProvider:Did you import the AppRootProvider context"
      ), D(!0);
      return;
    }
    let S;
    if ((($ = t == null ? void 0 : t.rootProps) == null ? void 0 : $.legacyMode) === !0 ? S = ft() : S = pt(), S === null) {
      c(!1), d("Error Validating the user"), process.env.NODE_ENV !== "production" && console.error("failed reading auth details from localstorage"), H() || (Le(), window.location.replace(L));
      return;
    }
    if (((oe = t == null ? void 0 : t.instance) == null ? void 0 : oe.OwIdFromPath) === null) {
      c(!1), d("Error fetching owId"), H() || (Le(), window.location.replace(L));
      return;
    }
    return Yn(
      ((Y = t.instance) == null ? void 0 : Y.originURL) ?? "",
      S.accessToken,
      F.signal
    ).then(() => {
      var z, j, De;
      const se = mt(
        {
          token: (S == null ? void 0 : S.accessToken) ?? "",
          originURL: ((z = t == null ? void 0 : t.instance) == null ? void 0 : z.originURL) ?? "",
          owIdHeaderKey: ((j = t == null ? void 0 : t.instance) == null ? void 0 : j.owIdHeaderKey) ?? "",
          owId: ((De = t == null ? void 0 : t.instance) == null ? void 0 : De.OwIdFromPath) ?? 1 / 0
        },
        (be, _e, ie) => {
          var le, ue;
          (ue = (le = t == null ? void 0 : t.rootProps) == null ? void 0 : le.attachInterceptorsToInstance) == null || ue.call(
            le,
            be,
            _e,
            ie
          ), Bt(be);
        }
      );
      T(S), y(() => se);
    }).catch((se) => {
      var z;
      se.name !== "CanceledError" && Hn(
        ((z = t.instance) == null ? void 0 : z.originURL) ?? "",
        (S == null ? void 0 : S.refreshToken) ?? "",
        F.signal
      ).then((j) => {
        var ue, Je, Ce, Ke, Qe, Re;
        const De = {
          owId: ((ue = t == null ? void 0 : t.instance) == null ? void 0 : ue.OwIdFromPath) ?? 1 / 0,
          access_token: j.access_token,
          refresh_token: j.refresh_token,
          scope: j.scope,
          token_type: j.token_type,
          expires_in: j.expires_in
        }, _e = {
          ...JSON.parse(
            localStorage.getItem(P.LEGACY_AUTH) ?? ""
          ),
          owId: ((Je = t == null ? void 0 : t.instance) == null ? void 0 : Je.OwIdFromPath) ?? 1 / 0,
          apiToken: j.access_token,
          refreshToken: j.refresh_token,
          expiresAt: j.expires_in
        };
        localStorage.setItem(
          P.AUTH,
          JSON.stringify(De)
        ), localStorage.setItem(
          P.LEGACY_AUTH,
          JSON.stringify(_e)
        );
        const ie = {
          accessToken: j.access_token,
          refreshToken: j.refresh_token,
          expiresIn: j.expires_in,
          tokenType: j.token_type,
          scope: j.scope,
          // @ts-ignore
          owId: ((Ce = t == null ? void 0 : t.instance) == null ? void 0 : Ce.OwIdFromPath) ?? 1 / 0
        }, le = mt(
          {
            token: (ie == null ? void 0 : ie.accessToken) ?? "",
            originURL: ((Ke = t == null ? void 0 : t.instance) == null ? void 0 : Ke.originURL) ?? "",
            owIdHeaderKey: ((Qe = t == null ? void 0 : t.instance) == null ? void 0 : Qe.owIdHeaderKey) ?? "",
            owId: ((Re = t == null ? void 0 : t.instance) == null ? void 0 : Re.OwIdFromPath) ?? 1 / 0
          },
          (ye, Xe, Ze) => {
            var fe, et;
            (et = (fe = t == null ? void 0 : t.rootProps) == null ? void 0 : fe.attachInterceptorsToInstance) == null || et.call(
              fe,
              ye,
              Xe,
              Ze
            ), Bt(ye);
          }
        );
        T(ie), y(() => le);
      }).catch(() => {
        c(!1), d("Invalid token"), H() || (Le(), window.location.replace(L));
      });
    }), () => F.abort();
  }, [t, L]);
  const O = ca({
    enabled: g !== null
  }), E = ua({
    enabled: g !== null
  }), A = la({
    enabled: g !== null
  }), U = da(
    ((ae = t == null ? void 0 : t.instance) == null ? void 0 : ae.OwIdFromPath) ?? 1 / 0,
    {
      enabled: g !== null
    }
  ), B = O.isFetching || E.isFetching || A.isFetching || U.isFetching, Z = O.isError || E.isError || A.isError || U.isError, ne = Ht((F) => {
    const S = [];
    if (F.indexOf("profile") >= 0) {
      const $ = O.refetch;
      S.push($());
    }
    if (F.indexOf("allowedApps") >= 0) {
      const $ = E.refetch;
      S.push($());
    }
    if (F.indexOf("chatbot") >= 0) {
      const $ = A.refetch;
      S.push($());
    }
    if (F.indexOf("customerConfig") >= 0) {
      const $ = U.refetch;
      S.push($());
    }
    return Promise.allSettled(S);
  });
  p.useEffect(() => {
    var F, S, $, oe;
    if (g !== null && !B) {
      if (Z) {
        if (O.isError && A.isError && U.isError && E.isError === !1 && E.data && (E.data || []).find(
          (se) => {
            var z;
            return se.appName === ((z = t == null ? void 0 : t.rootProps) == null ? void 0 : z.appName);
          }
        ) === void 0) {
          if (d("User does not have access to this app"), c(!1), D(!0), !H()) {
            const se = (E.data || []).find(
              (j) => j.appName === "Dashboard"
            ), z = oa(
              s,
              (F = t == null ? void 0 : t.instance) == null ? void 0 : F.OwIdFromPath,
              ((S = t == null ? void 0 : t.instance) == null ? void 0 : S.originURL) ?? "",
              se,
              ""
            );
            window.location.replace(z);
          }
          return;
        }
        c(!1), d("Error loading data"), D(!0), process.env.NODE_ENV !== "production" && (O.isError && console.error(O.error), E.isError && console.error(E.error), A.isError && console.error(A.error), U.isError && console.error(U.error));
        return;
      }
      if (O.data && E.data && A.data && U.data && w) {
        const Y = new na({
          profileData: O.data,
          authData: w,
          intercomId: A.data.chatbotAppId,
          customerConfigData: U.data ?? {},
          appRootInst: t.instance,
          currentApp: ($ = t.rootProps) == null ? void 0 : $.appName,
          legacyMode: t.rootProps.legacyMode ?? !0,
          useNewCrossLoginURL: t.rootProps.useNewCrossLoginURL ?? !1,
          allowedApps: E.data,
          refetchQueries: ne
        });
        if (E.data.find(
          (z) => {
            var j;
            return z.appName === ((j = t == null ? void 0 : t.rootProps) == null ? void 0 : j.appName);
          }
        ) === void 0) {
          if (d("User does not have access to this app"), c(!1), !H()) {
            const z = Y.getAppData("Dashboard"), j = Y.prepareAppSwitchingURL(z);
            window.location.replace(j);
          }
          return;
        }
        if (Y.isWorkspaceSuspended && !(t != null && t.rootProps.disableRedirectWhenWorkspaceIsSuspended)) {
          const z = Y == null ? void 0 : Y.getAppData("Marketplace");
          if (!H() && z) {
            const j = Y.prepareAppSwitchingURL(
              z,
              "/suspended"
            );
            window.location.replace(j);
            return;
          } else
            d("workspace is suspended"), c(!1);
        }
        if (r == null || r.setUser({
          owId: Y.loggedInOwId,
          userEmail: Y.userEmail,
          userName: Y.userDisplayName,
          organizationName: Y.organizationName
        }), h(Y), c(!1), s)
          try {
            const j = {
              ...{
                apiToken: w.accessToken,
                refreshToken: w.refreshToken,
                owId: ((oe = t == null ? void 0 : t.instance) == null ? void 0 : oe.OwIdFromPath) ?? 1 / 0,
                expiresAt: w.expiresIn
              },
              ...O.data,
              domainURL: Rt(x)
            };
            localStorage.setItem(
              P.LEGACY_AUTH,
              JSON.stringify(j)
            );
          } catch {
          }
        return;
      }
      d("Error occured while loading app init data"), c(!1), D(!0);
    }
  }, [
    B,
    Z,
    O.data,
    E.data,
    A.data,
    U.data,
    O.error,
    E.error,
    U.error,
    A.error,
    O.isError,
    A.isError,
    E.isError,
    U.isError,
    w,
    g,
    r,
    t,
    ne,
    s,
    x
  ]), p.useEffect(() => {
    const F = () => {
      const S = s ? ft() : pt();
      !(S != null && S.accessToken) && H() === !1 && (Le(), window.location.replace(L));
    };
    return window.addEventListener(
      "storage",
      F
    ), () => {
      window.removeEventListener(
        "storage",
        F
      );
    };
  }, [s, L]);
  const de = H() ? "App Initialzing..." : null, pe = H() ? l : _ ? "Error Loading App" : null;
  return /* @__PURE__ */ o.jsx(
    Lt.Provider,
    {
      value: {
        appMeta: m,
        apiInstance: g,
        allowedApps: E.data ?? []
      },
      children: i ? de : l !== "" ? pe : /* @__PURE__ */ o.jsx(
        br,
        {
          enableIntercom: (we = t == null ? void 0 : t.rootProps) == null ? void 0 : we.enableIntercom,
          children: e
        }
      )
    }
  );
}, ca = (n) => ke(
  Ne.keys({
    scope: "getProfileData"
  }),
  Bn,
  {
    enabled: n == null ? void 0 : n.enabled,
    staleTime: 1 / 0
  }
), la = (n) => ke(
  Ne.keys({
    scope: "getChatBotConfig"
  }),
  Wn,
  {
    enabled: n == null ? void 0 : n.enabled,
    staleTime: 1 / 0
  }
), ua = (n) => ke(
  Ne.keys({
    scope: "getAllowedApplications"
  }),
  Mn,
  {
    enabled: n == null ? void 0 : n.enabled,
    staleTime: 1 / 0
  }
), da = (n, e) => ke(
  Tn.keys({
    scope: "getCustomerConfig",
    loggedInOwId: n
  }),
  Vn,
  {
    enabled: e == null ? void 0 : e.enabled,
    staleTime: 1 / 0
  }
), pa = ({
  authData: n,
  owId: e,
  originURL: t,
  onComplete: r
}) => {
  const [s, i] = p.useState(
    null
  ), c = p.useRef(null), l = Ht(
    (g) => r == null ? void 0 : r(g)
  );
  p.useEffect(() => {
    if (!n || !e)
      return;
    if (localStorage.setItem(P.AUTH, JSON.stringify(n)), localStorage.setItem(P.LAST_OWID, JSON.stringify(e)), H())
      localStorage.setItem(
        P.LEGACY_OWIDS_ARRAY,
        JSON.stringify([Number(e)])
      );
    else {
      const y = JSON.parse(
        localStorage.getItem(P.LEGACY_OWIDS_ARRAY) ?? "[]"
      ), _ = y.indexOf(Number(e));
      _ >= 0 ? c.current = _ : (y.push(Number(e)), c.current = y.length - 1), localStorage.setItem(
        P.LEGACY_OWIDS_ARRAY,
        JSON.stringify(y)
      );
    }
    const g = mt({
      token: n.access_token ?? "",
      originURL: t ?? "",
      owIdHeaderKey: nr,
      owId: Number(e)
    });
    i(() => g);
  }, [i, n, t, e, l]);
  const { data: d, isFetching: m, isError: h } = ke(
    Ne.keys({ scope: "getProfileData" }),
    qn,
    {
      meta: {
        instance: s
      },
      enabled: s !== null
    }
  );
  p.useEffect(() => {
    if (s !== null && !m) {
      if (h) {
        l({
          error: "Failed to fetch profile data",
          owIdIndex: -1,
          isError: !0
        });
        return;
      }
      if (d) {
        const g = {
          // profile data
          ...d,
          // auth data
          apiToken: n.access_token,
          refreshToken: n.refresh_token,
          owId: Number(e),
          expiresAt: n.expires_in,
          //
          domainURL: Rt(t)
        };
        localStorage.setItem(
          P.LEGACY_AUTH,
          JSON.stringify(g)
        ), l({
          profileData: d,
          owIdIndex: H() ? 0 : c.current ?? 0,
          isError: !1
        });
      }
    }
  }, [
    m,
    h,
    s,
    d,
    e,
    n,
    l,
    t
  ]);
}, fa = (n, e) => ke(
  Ne.keys({
    scope: "getInitData"
  }),
  Nn,
  {
    enabled: e == null ? void 0 : e.enabled,
    staleTime: 1 / 0,
    meta: {
      axiosInstance: n
    }
  }
), ga = (n, e) => ke(
  Ne.keys({
    scope: "getInitChatBotConfig"
  }),
  Cn,
  {
    enabled: e == null ? void 0 : e.enabled,
    staleTime: 1 / 0,
    meta: {
      axiosInstance: n
    }
  }
), ha = (n) => {
  var e, t;
  (t = qt) == null || t(
    n.errorObjects ? (e = n.errorObjects[0]) == null ? void 0 : e.error : "Something went wrong!",
    {
      variant: "error"
    }
  );
}, ma = (n, e) => nn(
  Un.keys({
    ...n,
    scope: "__getAllowedOrganizationList"
  }),
  Fn,
  {
    onError: ha,
    enabled: e == null ? void 0 : e.enabled,
    getNextPageParam: (r, s) => s.reduce((c, l) => {
      var d;
      return c += ((d = l == null ? void 0 : l.data) == null ? void 0 : d.length) ?? 0, c;
    }, 0) < ((r == null ? void 0 : r.filteredRecords) ?? -1) ? s.length + 1 : null
  }
), $o = (n) => {
  const e = wr(), t = p.useMemo(
    () => e == null ? void 0 : e.getDatadogInstance(),
    [e]
  ), r = n.matches[n.matches.length - 1];
  p.useEffect(() => {
    t && t.startView({ name: r == null ? void 0 : r.routeId });
  }, [r == null ? void 0 : r.routeId, r == null ? void 0 : r.id]);
}, wa = async (n, e) => {
  var t;
  try {
    const r = await n.post("/v3/ua/login", {
      ...e,
      grantType: "password"
    });
    if (r.data.success) {
      const { data: s } = r.data;
      return s;
    }
    throw { response: r };
  } catch (r) {
    return Promise.reject((t = r == null ? void 0 : r.response) == null ? void 0 : t.data);
  }
}, ya = ({ initData: n }) => {
  const [e, t] = p.useState(!1), { instance: r } = Ge() ?? {}, s = r == null ? void 0 : r.originURL, i = (w) => (T, L) => {
    t(L ? w : !1);
  }, [c, l] = p.useState(n), [d, m] = p.useState(!1), [h, g] = p.useState(""), [y, _] = p.useState();
  pa({
    authData: y,
    owId: (y == null ? void 0 : y.owId) ?? -1,
    originURL: r.originURL,
    onComplete: ({ profileData: w, isError: T, owIdIndex: L }) => {
      console.log(w, T, L), T || window.location.reload();
    }
  });
  const D = async (w) => {
    try {
      g(""), m(!0);
      const { ...T } = w, L = new URL("/api", s), x = Q.create({
        baseURL: L.toString(),
        headers: {
          Authorization: At
        }
      }), O = await wa(x, T);
      O && _(O);
    } catch (T) {
      g(JSON.stringify(T));
    } finally {
      m(!1);
    }
  };
  return /* @__PURE__ */ o.jsxs(
    wt,
    {
      expanded: e === "userLoginPanel",
      onChange: i("userLoginPanel"),
      children: [
        /* @__PURE__ */ o.jsx(
          yt,
          {
            "aria-controls": "userLoginPanel-content",
            id: "userLoginPanel-header",
            classes: {
              content: he({
                alignItems: "center",
                justifyContent: "between",
                my: 4
              })
            },
            children: /* @__PURE__ */ o.jsx(J, { variant: "bodyMedium", weight: "demi", gutterBottom: !1, children: "User Login Settings" })
          }
        ),
        h && /* @__PURE__ */ o.jsx(Ye, { severity: "error", children: h }),
        /* @__PURE__ */ o.jsx(It, { children: /* @__PURE__ */ o.jsxs(
          C,
          {
            Component: "form",
            onSubmit: (w) => {
              w.preventDefault(), D(c);
            },
            sx: { display: "flex", flexDirection: "column", gap: 12 },
            children: [
              "OriginURL: ",
              /* @__PURE__ */ o.jsx(vt, { label: s ?? "" }),
              /* @__PURE__ */ o.jsx(
                He,
                {
                  type: "email",
                  label: "Email",
                  variant: "outlined",
                  placeholder: "User Email",
                  value: c == null ? void 0 : c.email,
                  fullWidth: !0,
                  id: "email",
                  name: "email",
                  onChange: (w) => (
                    // @ts-ignore
                    l((T) => ({ ...T, email: w.target.value }))
                  )
                }
              ),
              /* @__PURE__ */ o.jsx(
                He,
                {
                  label: "Password",
                  type: "password",
                  variant: "outlined",
                  placeholder: "Password",
                  value: c == null ? void 0 : c.password,
                  fullWidth: !0,
                  id: "password",
                  name: "password",
                  onChange: (w) => (
                    // @ts-ignore
                    l((T) => ({ ...T, password: w.target.value }))
                  )
                }
              ),
              /* @__PURE__ */ o.jsx(
                bt,
                {
                  type: "submit",
                  loading: d,
                  loadingPosition: "end",
                  children: "Login"
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}, Ia = () => {
  const [n, e] = p.useState(!1), t = (h) => (g, y) => {
    e(y ? h : !1);
  }, [r, s] = p.useState(""), [i, c] = p.useState(!1), [l, d] = p.useState(""), m = async (h) => {
    try {
      c(!0), localStorage.setItem(P.LAST_OWID, h), localStorage.setItem(
        P.LEGACY_OWIDS_ARRAY,
        JSON.stringify([h])
      ), window.location.reload();
    } catch (g) {
      s(JSON.stringify(g));
    } finally {
      c(!1);
    }
  };
  return /* @__PURE__ */ o.jsxs(
    wt,
    {
      expanded: n === "userLoginPanel",
      onChange: t("userLoginPanel"),
      children: [
        /* @__PURE__ */ o.jsx(
          yt,
          {
            "aria-controls": "userLoginPanel-content",
            id: "userLoginPanel-header",
            classes: {
              content: he({
                alignItems: "center",
                justifyContent: "between",
                my: 4
              })
            },
            children: /* @__PURE__ */ o.jsx(J, { variant: "bodyMedium", weight: "demi", gutterBottom: !1, children: "Org Switching" })
          }
        ),
        r && /* @__PURE__ */ o.jsx(Ye, { severity: "error", children: r }),
        /* @__PURE__ */ o.jsxs(
          It,
          {
            sx: { display: "flex", flexDirection: "column", gap: 12 },
            children: [
              /* @__PURE__ */ o.jsx(
                He,
                {
                  type: "number",
                  label: "OwId",
                  variant: "outlined",
                  placeholder: "Enter OwId",
                  value: l,
                  fullWidth: !0,
                  id: "owId",
                  name: "owId",
                  onChange: (h) => d(h.target.value)
                }
              ),
              /* @__PURE__ */ o.jsx(
                bt,
                {
                  loading: i,
                  loadingPosition: "end",
                  onClick: () => m(l),
                  children: "Switch ORG"
                }
              )
            ]
          }
        )
      ]
    }
  );
}, va = () => {
  const [n, e] = p.useState(!1), t = (h) => (g, y) => {
    e(y ? h : !1);
  }, [r, s] = p.useState(""), [i, c] = p.useState(!1), [l, d] = p.useState(""), m = async (h) => {
    try {
      c(!0), localStorage.setItem(P.ORIGIN_URL, h), window.location.reload();
    } catch (g) {
      s(JSON.stringify(g));
    } finally {
      c(!1);
    }
  };
  return /* @__PURE__ */ o.jsxs(
    wt,
    {
      expanded: n === "userLoginPanel",
      onChange: t("userLoginPanel"),
      children: [
        /* @__PURE__ */ o.jsx(
          yt,
          {
            "aria-controls": "userLoginPanel-content",
            id: "userLoginPanel-header",
            classes: {
              content: he({
                alignItems: "center",
                justifyContent: "between",
                my: 4
              })
            },
            children: /* @__PURE__ */ o.jsx(J, { variant: "bodyMedium", weight: "demi", gutterBottom: !1, children: "Origin URL" })
          }
        ),
        r && /* @__PURE__ */ o.jsx(Ye, { severity: "error", children: r }),
        /* @__PURE__ */ o.jsxs(
          It,
          {
            sx: { display: "flex", flexDirection: "column", gap: 12 },
            children: [
              /* @__PURE__ */ o.jsx(
                He,
                {
                  label: "OriginURL",
                  variant: "outlined",
                  placeholder: "Enter Origin URL",
                  value: l,
                  fullWidth: !0,
                  name: "originURL",
                  onChange: (h) => d(h.target.value)
                }
              ),
              /* @__PURE__ */ o.jsx(
                bt,
                {
                  loading: i,
                  loadingPosition: "end",
                  onClick: () => m(l),
                  children: "Switch Origin URL"
                }
              )
            ]
          }
        )
      ]
    }
  );
}, ba = "_root_1jv6s_1", _a = "_fadeIn_1jv6s_1", Ra = "_hideButton_1jv6s_18", Aa = "_fadeOut_1jv6s_1", Sa = "_buttonTopLeft_1jv6s_31", La = "_buttonTopRight_1jv6s_35", xa = "_buttonBottomLeft_1jv6s_39", Ea = "_buttonBottomRight_1jv6s_43", ka = "_drawerContainer_1jv6s_48", tt = {
  root: ba,
  fadeIn: _a,
  hideButton: Ra,
  fadeOut: Aa,
  buttonTopLeft: Sa,
  buttonTopRight: La,
  buttonBottomLeft: xa,
  buttonBottomRight: Ea,
  drawerContainer: ka
}, Da = function(e) {
  const {
    className: t,
    classes: r,
    position: s = "top-left",
    panelPosition: i = "right",
    sx: c,
    slotProps: l
  } = e, [d, m] = p.useState(!1), h = (g) => g.replace(/-([a-z])/g, (y, _) => _.toUpperCase()).replace(/^(.)/, (y) => y.toUpperCase()).replace(/-/g, "");
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(
      Me,
      {
        className: G(
          tt.root,
          r == null ? void 0 : r.root,
          tt[`button${h(s)}`],
          d && tt.hideButton,
          t,
          he(c)
        ),
        size: "large",
        onClick: () => m(!0),
        children: /* @__PURE__ */ o.jsx(vn, {})
      }
    ),
    /* @__PURE__ */ o.jsx(
      Jr,
      {
        open: d,
        anchor: i,
        onClose: () => {
          console.log("I am closing"), m(!1);
        },
        variant: "persistent",
        children: /* @__PURE__ */ o.jsxs(
          C,
          {
            className: G(tt.drawerContainer, r == null ? void 0 : r.drawerContainer),
            style: { width: 400 },
            children: [
              /* @__PURE__ */ o.jsxs(
                C,
                {
                  sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "between",
                    p: 12,
                    borderBottom: 1
                  },
                  children: [
                    /* @__PURE__ */ o.jsx(
                      J,
                      {
                        component: "h2",
                        variant: "h6",
                        weight: "demi",
                        gutterBottom: !1,
                        children: "Dev Tools"
                      }
                    ),
                    /* @__PURE__ */ o.jsx(Ee, { color: "secondary", onClick: () => m(!1), children: /* @__PURE__ */ o.jsx(bn, {}) })
                  ]
                }
              ),
              /* @__PURE__ */ o.jsxs(
                C,
                {
                  sx: {
                    display: "flex",
                    flexDirection: "column",
                    height: 100,
                    overflow: "auto",
                    p: 12
                  },
                  children: [
                    /* @__PURE__ */ o.jsx(ya, { ...l == null ? void 0 : l.authProps }),
                    /* @__PURE__ */ o.jsx(Ia, {}),
                    /* @__PURE__ */ o.jsx(va, {})
                  ]
                }
              )
            ]
          }
        )
      }
    )
  ] });
}, Oa = Da, Yo = process.env.NODE_ENV !== "development" ? function() {
  return null;
} : Oa, ja = "_root_wkzkn_1", Pa = "_superUser_wkzkn_14", Ta = "_workspaceUser_wkzkn_18", Ua = "_advertiserUser_wkzkn_22", Na = "_message_wkzkn_26", Ca = "_chip_wkzkn_35", Fa = "_link_wkzkn_39", ge = {
  root: ja,
  superUser: Pa,
  workspaceUser: Ta,
  advertiserUser: Ua,
  message: Na,
  chip: Ca,
  link: Fa
}, za = {
  [ce.ADVERTISER]: ge.advertiserUser,
  [ce.WORKSPACE]: ge.workspaceUser,
  [ce.SUPER]: ge.superUser
}, Ba = p.forwardRef(
  function(e, t) {
    var m, h;
    const { className: r, ...s } = e, { appMeta: i } = ve(), [c, l] = p.useState(i == null ? void 0 : i.isInfobarEnabled);
    if (!i)
      return process.env.NODE_ENV !== "production" ? /* @__PURE__ */ o.jsx(
        Ye,
        {
          className: G(ge.root, r),
          ref: t,
          ...s,
          icon: !1,
          variant: "filled",
          onClose: () => l(!1),
          classes: {
            ...s == null ? void 0 : s.classes,
            message: G(ge.message, (m = s == null ? void 0 : s.classes) == null ? void 0 : m.message)
          },
          children: "Did you import the AppRootProvier and AppProvider Context"
        }
      ) : null;
    const d = i.organizationHirerachy.map((g) => {
      const y = g;
      return g.isAccess ? /* @__PURE__ */ o.jsx(
        te,
        {
          arrow: !0,
          TypgraphyProps: {
            sx: { display: "block", width: 100 },
            component: Gt,
            className: ge.link,
            onClick: () => {
              const _ = i.prepareOrganizationSwitchingURL(y);
              window.open(_, "_blank");
            }
          },
          children: y.organizationName
        },
        y.owId
      ) : /* @__PURE__ */ o.jsx(
        te,
        {
          arrow: !0,
          TypgraphyProps: { sx: { display: "block" } },
          children: y.organizationName
        },
        y.owId
      );
    });
    return c ? /* @__PURE__ */ o.jsxs(
      Ye,
      {
        className: G(
          ge.root,
          za[i.organizationType],
          r
        ),
        ref: t,
        ...s,
        icon: !1,
        variant: "filled",
        onClose: () => l(!1),
        classes: {
          ...s == null ? void 0 : s.classes,
          message: G(ge.message, (h = s == null ? void 0 : s.classes) == null ? void 0 : h.message)
        },
        children: [
          /* @__PURE__ */ o.jsx(
            vt,
            {
              className: ge.chip,
              size: "small",
              label: i.isUserOrganizationOwner ? "Owner" : "User",
              sx: { flexShrink: 0 }
            }
          ),
          /* @__PURE__ */ o.jsx(J, { sx: { flexShrink: 0 }, children: "Logged in as" }),
          /* @__PURE__ */ o.jsx(
            te,
            {
              arrow: !0,
              TypgraphyProps: { weight: "demi" },
              sx: { maxWidth: 100 },
              children: i.userDisplayName || i.userEmail
            }
          ),
          /* @__PURE__ */ o.jsx(J, { sx: { flexShrink: 0 }, children: " in " }),
          /* @__PURE__ */ o.jsx(
            Kr,
            {
              "aria-label": "breadcrumb",
              separator: /* @__PURE__ */ o.jsx(_n, {}),
              sx: { maxWidth: 100, overflow: "hidden" },
              classes: {
                ol: he({ flexWrap: "nowrap", overflow: "hidden", maxWidth: 100 }),
                li: he({ overflow: "hidden", maxWidth: 100 }),
                separator: he({ flexShrink: 0 })
              },
              children: d
            }
          )
        ]
      }
    ) : null;
  }
);
Ba.displayName = "InfoBar";
const Wa = "_root_10bq1_1", Ma = "_title_10bq1_13", Va = "_icon_10bq1_20", $a = "_beta_10bq1_32", Ya = "_content_10bq1_42", Ha = "_nav_10bq1_49", Se = {
  root: Wa,
  title: Ma,
  icon: Va,
  beta: $a,
  content: Ya,
  nav: Ha
}, qa = () => {
  const [n, e] = p.useState(!1);
  p.useEffect(() => {
    if (!sessionStorage.getItem("responsiveAlertShown")) {
      const { matches: r } = window.matchMedia("(max-width: 1200px)");
      e(r);
    }
  }, []);
  const t = () => {
    e(!1), sessionStorage.setItem("responsiveAlertShown", "true");
  };
  return /* @__PURE__ */ o.jsx(
    Qr,
    {
      maxWidth: "xs",
      open: n,
      onClose: () => e(!1),
      PaperProps: { sx: { py: 32 } },
      children: /* @__PURE__ */ o.jsxs(
        Xr,
        {
          sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center"
          },
          children: [
            /* @__PURE__ */ o.jsx(
              Dn,
              {
                sx: { width: 75, height: "auto", textColor: "primary-500", mb: 24 }
              }
            ),
            /* @__PURE__ */ o.jsxs(
              C,
              {
                sx: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  gap: 8
                },
                children: [
                  /* @__PURE__ */ o.jsx(
                    J,
                    {
                      component: "h1",
                      variant: "bodyLarge",
                      weight: "demi",
                      gutterBottom: !1,
                      children: "Want a better Experience?"
                    }
                  ),
                  /* @__PURE__ */ o.jsx(J, { component: "p", gutterBottom: !1, children: "Use a tablet or computer for a better and smoother platform experience." })
                ]
              }
            ),
            /* @__PURE__ */ o.jsx(Me, { onClick: t, sx: { mt: 16 }, children: "Ok, Got It" })
          ]
        }
      )
    }
  );
}, Ga = () => {
  const n = Zn(), { appMeta: e } = ve(), [t, r] = p.useState(!1), [s, i] = p.useState(0);
  return p.useEffect(() => {
    n == null || n.onIntercomShow(() => {
      r(!0);
    }), n == null || n.onIntercomHide(() => {
      r(!1);
    }), n == null || n.onIntercomeUnreadCountChange((c) => {
      i(c);
    });
  }, [n, r]), e.intercomId ? /* @__PURE__ */ o.jsx(xe, { title: "Chat", arrow: !0, children: /* @__PURE__ */ o.jsx(Jt, { badgeContent: s, children: /* @__PURE__ */ o.jsx(
    Ee,
    {
      color: "secondary",
      onClick: () => {
        t ? n == null || n.hideIntercom() : n == null || n.showIntercom();
      },
      children: /* @__PURE__ */ o.jsx(Rn, {})
    }
  ) }) }) : null;
}, Ja = "_drawer_bv1mw_1", Ka = "_appDrawer_bv1mw_14", Qa = "_appList_bv1mw_22", Xa = "_appListItem_bv1mw_33", Za = "_appListItemLink_bv1mw_38", eo = "_appListItemLinkIcon_bv1mw_52", to = "_appListItemLinkText_bv1mw_55", ro = "_active_bv1mw_77", no = "_disabled_bv1mw_85", Ie = {
  drawer: Ja,
  appDrawer: Ka,
  appList: Qa,
  appListItem: Xa,
  appListItemLink: Za,
  appListItemLinkIcon: eo,
  appListItemLinkText: to,
  active: ro,
  disabled: no
}, Rr = () => {
  const n = Kt({
    variant: "popper",
    popupId: "appsPopper"
  }), { allowedApps: e, appMeta: t } = ve(), r = Ge(), i = p.useMemo(() => e.filter((c) => c.showInDrawer), [e]).map((c) => {
    var h;
    const l = On[c.appName] ?? Ve, d = ((h = r == null ? void 0 : r.rootProps) == null ? void 0 : h.appName) === c.appName, m = t.prepareAppSwitchingURL(c);
    return /* @__PURE__ */ o.jsx("li", { className: Ie.appListItem, children: /* @__PURE__ */ o.jsxs(
      at,
      {
        href: m,
        className: G(
          Ie.appListItemLink,
          d && [Ie.active]
        ),
        children: [
          l && /* @__PURE__ */ o.jsx(l, { fontSize: 48, className: Ie.appListItemLinkIcon }),
          /* @__PURE__ */ o.jsx(
            J,
            {
              component: "h2",
              variant: "bodySmall",
              weight: "demi",
              gutterBottom: !1,
              className: Ie.appListItemLinkText,
              children: c.appName
            }
          )
        ]
      }
    ) }, c.appId);
  });
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(xe, { title: "All your Apps", arrow: !0, children: /* @__PURE__ */ o.jsx(
      Ee,
      {
        color: "secondary",
        ...Qt(n),
        selected: n.isOpen,
        children: /* @__PURE__ */ o.jsx(An, {})
      }
    ) }),
    /* @__PURE__ */ o.jsx(Xt, { ...Zt(n), placement: "bottom-end", children: /* @__PURE__ */ o.jsx(er, { onClickAway: n.close, children: /* @__PURE__ */ o.jsx(tr, { className: G(Ie.drawer, Ie.appDrawer), children: /* @__PURE__ */ o.jsx("ul", { className: Ie.appList, children: i }) }) }) })
  ] });
};
Rr.displayName = "AppsDrawer";
const ao = "_button_pyl2v_1", oo = "_badge_pyl2v_7", so = "_drawer_pyl2v_11", io = "_profileDrawer_pyl2v_24", co = "_avatar_pyl2v_32", lo = "_workspace_pyl2v_38", uo = "_user_pyl2v_42", po = "_organization_pyl2v_43", fo = "_info_pyl2v_52", go = "_skeleton_pyl2v_65", ho = "_profileList_pyl2v_69", mo = "_active_pyl2v_82", wo = "_profileActions_pyl2v_96", yo = "_noOrganizationAvailable_pyl2v_103", M = {
  button: ao,
  badge: oo,
  drawer: so,
  profileDrawer: io,
  avatar: co,
  workspace: lo,
  user: uo,
  organization: po,
  info: fo,
  skeleton: go,
  profileList: ho,
  active: mo,
  profileActions: wo,
  noOrganizationAvailable: yo
}, rt = (n) => {
  const { variant: e = "allowedOrgs" } = n;
  return /* @__PURE__ */ o.jsxs(at, { href: "#", className: G(M.organization, M.skeleton), children: [
    /* @__PURE__ */ o.jsx(
      Pe,
      {
        variant: "circular",
        width: 40,
        height: 40,
        className: M.avatar
      }
    ),
    /* @__PURE__ */ o.jsxs(C, { className: M.info, children: [
      /* @__PURE__ */ o.jsx(Pe, { children: /* @__PURE__ */ o.jsx(
        te,
        {
          TypgraphyProps: {
            component: "h2",
            variant: "bodyMedium",
            weight: "demi",
            gutterBottom: !1
          },
          arrow: !0,
          children: "User Name - Proflie"
        }
      ) }),
      /* @__PURE__ */ o.jsxs(
        C,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            width: 100,
            gap: 4
          },
          children: [
            /* @__PURE__ */ o.jsx(Pe, { children: /* @__PURE__ */ o.jsx(
              te,
              {
                TypgraphyProps: {
                  component: "h3",
                  variant: "bodySmall",
                  gutterBottom: !1
                },
                arrow: !0,
                children: "userEmail@iqm.comuserEmail@iqm.com"
              }
            ) }),
            e === "allowedOrgs" && /* @__PURE__ */ o.jsx(
              Pe,
              {
                variant: "rounded",
                width: 18,
                height: 18,
                sx: { flexShrink: 0 },
                children: /* @__PURE__ */ o.jsx(Ee, { href: "/copyEmail", sx: { flexShrink: 0 }, size: "small", children: /* @__PURE__ */ o.jsx(rr, {}) })
              }
            )
          ]
        }
      ),
      e === "allowedOrgs" && /* @__PURE__ */ o.jsxs(
        C,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            width: 100,
            gap: 4
          },
          children: [
            /* @__PURE__ */ o.jsx(Pe, { children: /* @__PURE__ */ o.jsx(
              J,
              {
                component: "label",
                variant: "bodySmall",
                gutterBottom: !1,
                sx: { textColor: "neutral-500", flexShrink: 0 },
                children: "Owner :"
              }
            ) }),
            /* @__PURE__ */ o.jsx(Pe, { children: /* @__PURE__ */ o.jsx(
              te,
              {
                TypgraphyProps: {
                  component: "h3",
                  variant: "bodySmall",
                  gutterBottom: !1
                },
                arrow: !0,
                children: "Owner User Name"
              }
            ) })
          ]
        }
      )
    ] })
  ] });
}, xt = (n) => n.organizationType === "SUPER" || n.organizationType === "WORKSPACE" ? /* @__PURE__ */ o.jsx(
  Jt,
  {
    color: "primary",
    overlap: "circular",
    variant: "dot",
    size: "small",
    badgeContent: /* @__PURE__ */ o.jsx(Sn, {}),
    classes: { badge: M.badge },
    children: /* @__PURE__ */ o.jsx(
      dt,
      {
        size: n.size,
        className: G(M.avatar, M.workspace),
        src: n.src
      }
    )
  }
) : /* @__PURE__ */ o.jsx(dt, { size: n.size, className: M.avatar, src: n.src }), Ar = (n) => n.customerType === "Advertiser" ? ce.ADVERTISER : n.customerType === "Workspace" ? ce.WORKSPACE : ce.SUPER, Io = (n) => {
  const { organizationDetails: e, prepareOrganizationSwitchingURL: t } = n, r = Ar(e), { copy: s } = Zr(e.workspaceDomain);
  return /* @__PURE__ */ o.jsxs(
    at,
    {
      className: G(M.organization),
      onClick: () => {
        const i = t(e);
        window.open(i, "_blank");
      },
      children: [
        /* @__PURE__ */ o.jsx(
          xt,
          {
            size: 40,
            organizationType: r,
            src: e == null ? void 0 : e.logoUrl
          }
        ),
        /* @__PURE__ */ o.jsxs(C, { className: M.info, children: [
          /* @__PURE__ */ o.jsx(
            te,
            {
              TypgraphyProps: {
                component: "h2",
                variant: "bodyMedium",
                weight: "demi",
                gutterBottom: !1,
                align: "left"
              },
              arrow: !0,
              children: e == null ? void 0 : e.organizationName
            }
          ),
          /* @__PURE__ */ o.jsxs(
            C,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                width: 100,
                gap: 4
              },
              children: [
                /* @__PURE__ */ o.jsx(
                  te,
                  {
                    TypgraphyProps: {
                      component: "h3",
                      variant: "bodySmall",
                      gutterBottom: !1
                    },
                    arrow: !0,
                    children: r === "WORKSPACE" ? e == null ? void 0 : e.workspaceDomain : e == null ? void 0 : e.workspaceOwnerOrganizationName
                  }
                ),
                r === "WORKSPACE" && /* @__PURE__ */ o.jsx(
                  Ee,
                  {
                    Component: "button",
                    sx: { flexShrink: 0 },
                    size: "small",
                    onClick: (i) => {
                      i.preventDefault(), i.stopPropagation(), s();
                    },
                    children: /* @__PURE__ */ o.jsx(rr, {})
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ o.jsxs(
            C,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                width: 100,
                gap: 4
              },
              children: [
                /* @__PURE__ */ o.jsx(
                  J,
                  {
                    component: "label",
                    variant: "bodySmall",
                    gutterBottom: !1,
                    sx: { textColor: "neutral-500", flexShrink: 0 },
                    children: "Owner :"
                  }
                ),
                /* @__PURE__ */ o.jsxs(
                  te,
                  {
                    TypgraphyProps: {
                      component: "h3",
                      variant: "bodySmall",
                      gutterBottom: !1
                    },
                    arrow: !0,
                    children: [
                      e == null ? void 0 : e.contactPersonName,
                      " (",
                      e == null ? void 0 : e.ownerUserEmail,
                      ")"
                    ]
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}, vo = (n) => {
  const e = Ar(n);
  return /* @__PURE__ */ o.jsxs(C, { className: M.organization, children: [
    /* @__PURE__ */ o.jsx(
      xt,
      {
        size: 40,
        organizationType: e,
        src: n.logoUrl
      }
    ),
    /* @__PURE__ */ o.jsxs(C, { className: M.info, children: [
      /* @__PURE__ */ o.jsx(
        te,
        {
          TypgraphyProps: {
            component: "h2",
            variant: "bodyMedium",
            weight: "demi",
            gutterBottom: !1
          },
          arrow: !0,
          children: n == null ? void 0 : n.organizationName
        }
      ),
      /* @__PURE__ */ o.jsxs(
        C,
        {
          sx: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            width: 100,
            gap: 4
          },
          children: [
            /* @__PURE__ */ o.jsx(
              J,
              {
                component: "label",
                variant: "bodySmall",
                gutterBottom: !1,
                sx: { textColor: "neutral-500", flexShrink: 0 },
                children: "Owner :"
              }
            ),
            /* @__PURE__ */ o.jsxs(
              te,
              {
                TypgraphyProps: {
                  component: "h3",
                  variant: "bodySmall",
                  gutterBottom: !1
                },
                arrow: !0,
                children: [
                  n == null ? void 0 : n.contactPersonName,
                  " (",
                  n == null ? void 0 : n.ownerUserEmail,
                  ")"
                ]
              }
            )
          ]
        }
      )
    ] })
  ] });
}, bo = () => /* @__PURE__ */ o.jsxs(
  C,
  {
    sx: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      p: 12,
      textAlign: "center",
      height: 100
    },
    children: [
      /* @__PURE__ */ o.jsx(Ln, { fontSize: 40, sx: { textColor: "neutral-500" } }),
      /* @__PURE__ */ o.jsx(
        J,
        {
          component: "h2",
          variant: "bodyMedium",
          weight: "demi",
          sx: { my: 8 },
          children: "No results found"
        }
      ),
      /* @__PURE__ */ o.jsx(J, { children: "We can't find any items matching your search" })
    ]
  }
), Sr = () => {
  var O, E;
  const n = Kt({
    variant: "popper",
    popupId: "profilePopper"
  }), { appMeta: e } = ve(), [t, r] = p.useState(""), [s, i] = p.useState(void 0), c = p.useRef(!1), [l, d] = p.useState(!1), [m, h] = p.useState(null), g = en(t, 200), y = e.getAppData("My Profile");
  let _ = "", D = "";
  y && (_ = e.prepareAppSwitchingURL(y), D = e.prepareAppSwitchingURL(
    y,
    "/organizations"
  ));
  const w = ma({
    isOrganizationAccess: !1,
    limit: 4,
    sortBy: "-lastActive",
    searchField: g
  });
  p.useEffect(() => {
    var A, U, B;
    (w.isLoading || w.isFetching) === !1 && c.current === !1 && (c.current = !0, i(((B = (U = (A = w == null ? void 0 : w.data) == null ? void 0 : A.pages) == null ? void 0 : U[0]) == null ? void 0 : B.data) ?? []));
  }, [
    w.isLoading,
    w.isFetching,
    w.data,
    s,
    i
  ]);
  const T = p.useMemo(() => {
    var A, U, B, Z, ne, de;
    return w.isFetching ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx(rt, {}, 0),
      /* @__PURE__ */ o.jsx(rt, {}, 1),
      /* @__PURE__ */ o.jsx(rt, {}, 2)
    ] }) : (((B = (U = (A = w.data) == null ? void 0 : A.pages) == null ? void 0 : U[0]) == null ? void 0 : B.data.length) ?? 0) > 0 ? (de = (ne = (Z = w.data) == null ? void 0 : Z.pages) == null ? void 0 : ne[0]) == null ? void 0 : de.data.map((pe) => /* @__PURE__ */ o.jsx(
      Io,
      {
        organizationDetails: pe,
        prepareOrganizationSwitchingURL: e.prepareOrganizationSwitchingURL
      },
      pe.owId
    )) : null;
  }, [
    w.isFetching,
    w.data,
    e.prepareOrganizationSwitchingURL
  ]);
  p.useEffect(() => {
    var A, U, B;
    w.data && m === null && (B = (U = (A = w == null ? void 0 : w.data) == null ? void 0 : A.pages) == null ? void 0 : U[0]) != null && B.currentOrganization && h(w.data.pages[0].currentOrganization);
  }, [h, w.data, m]);
  const L = ((s == null ? void 0 : s.length) ?? 0) <= 0, x = async () => {
    try {
      d(!0);
      const A = await $n();
      qt(A);
    } catch {
    } finally {
      d(!1), e.logout();
    }
  };
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(xe, { enterDelay: 1e3, title: e.organizationName, arrow: !0, children: /* @__PURE__ */ o.jsx(
      Me,
      {
        variant: "text",
        color: "secondary",
        className: M.button,
        startIcon: /* @__PURE__ */ o.jsx(
          xt,
          {
            size: 24,
            src: e.organizationLogo,
            organizationType: e.organizationType
          }
        ),
        ...Qt(n),
        selected: n.isOpen,
        children: /* @__PURE__ */ o.jsx(J, { noWrap: !0, gutterBottom: !1, children: e.organizationName })
      }
    ) }),
    /* @__PURE__ */ o.jsx(Xt, { ...Zt(n), placement: "bottom-end", children: /* @__PURE__ */ o.jsx(er, { onClickAway: n.close, children: /* @__PURE__ */ o.jsxs(tr, { className: G(M.drawer, M.profileDrawer), children: [
      /* @__PURE__ */ o.jsxs(C, { className: M.user, children: [
        /* @__PURE__ */ o.jsx(
          dt,
          {
            size: 64,
            color: "primary",
            className: M.avatar,
            src: e.userAvatar
          }
        ),
        /* @__PURE__ */ o.jsxs(C, { className: M.info, children: [
          /* @__PURE__ */ o.jsx(
            te,
            {
              TypgraphyProps: {
                component: "h2",
                variant: "bodyLarge",
                weight: "demi",
                gutterBottom: !1
              },
              arrow: !0,
              children: e.userDisplayName
            }
          ),
          /* @__PURE__ */ o.jsx(
            te,
            {
              TypgraphyProps: {
                component: "h3",
                variant: "bodySmall",
                sx: { mb: 4 }
              },
              arrow: !0,
              children: e.userEmail
            }
          ),
          /* @__PURE__ */ o.jsx(
            Gt,
            {
              href: _,
              sx: { textWeight: "demi" },
              children: "Manage my profile"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ o.jsx(C, { sx: { px: 12 }, children: m === null ? /* @__PURE__ */ o.jsx(rt, { variant: "currentOrg" }) : /* @__PURE__ */ o.jsx(vo, { ...m }) }),
      /* @__PURE__ */ o.jsx(zt, { color: "secondary" }),
      L === !1 ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
        /* @__PURE__ */ o.jsx(C, { sx: { px: 12 }, children: /* @__PURE__ */ o.jsx(
          xe,
          {
            title: "Search other organization by name, email or ID",
            placement: "top",
            arrow: !0,
            children: /* @__PURE__ */ o.jsx(
              He,
              {
                variant: "outlinedDash",
                placeholder: "Search other organization by name, email or ID",
                InputProps: {
                  startAdornment: /* @__PURE__ */ o.jsx(xn, {})
                },
                onChange: (A) => {
                  r(A.target.value);
                },
                defaultValue: t,
                fullWidth: !0
              }
            )
          }
        ) }),
        /* @__PURE__ */ o.jsx(C, { className: M.profileList, children: (((E = (O = w.data) == null ? void 0 : O.pages[0]) == null ? void 0 : E.data.length) ?? 0) > 0 || w.isFetching ? T : /* @__PURE__ */ o.jsx(bo, {}) }),
        /* @__PURE__ */ o.jsx(zt, { color: "secondary" })
      ] }) : null,
      /* @__PURE__ */ o.jsxs(
        C,
        {
          className: G(
            M.profileActions,
            L && M.noOrganizationAvailable
          ),
          children: [
            L === !1 ? /* @__PURE__ */ o.jsx(
              Me,
              {
                variant: "outlined",
                Component: "a",
                href: D,
                children: "See all accesses"
              }
            ) : null,
            /* @__PURE__ */ o.jsx(Me, { disabled: l, onClick: x, children: "Logout" })
          ]
        }
      )
    ] }) }) })
  ] });
};
Sr.displayName = "ProfileDrawer";
const _o = (n = "") => {
  var e, t;
  return ((t = (e = n ?? "") == null ? void 0 : e.split(/[_,-]/)) == null ? void 0 : t[0]) ?? "";
}, Ro = p.forwardRef(
  function(e, t) {
    var _, D, w, T, L, x, O, E;
    const {
      className: r,
      classes: s,
      children: i,
      sx: c,
      appLogo: l,
      hideAppName: d = !1,
      ...m
    } = e, { appMeta: h } = ve(), g = Ge();
    if (tn(h == null ? void 0 : h.favicon), rn(((_ = g == null ? void 0 : g.rootProps) == null ? void 0 : _.appName) ?? ""), !g || !h)
      return /* @__PURE__ */ o.jsx(
        C,
        {
          ref: t,
          className: G(Se.root, s == null ? void 0 : s.root, r, he(c)),
          ...m,
          children: "Did you import the AppRootProvier and AppProvider Context"
        }
      );
    const y = l ?? g.rootProps.appLogo ?? /* @__PURE__ */ o.jsx(Ve, {});
    return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsxs(
        C,
        {
          ref: t,
          className: G(Se.root, s == null ? void 0 : s.root, r, he(c)),
          ...m,
          children: [
            /* @__PURE__ */ o.jsx(
              xe,
              {
                title: (D = g == null ? void 0 : g.rootProps) != null && D.appVersion ? `${(w = g == null ? void 0 : g.rootProps) == null ? void 0 : w.appName} - ${_o((T = g == null ? void 0 : g.rootProps) == null ? void 0 : T.appVersion)}` : "",
                arrow: !0,
                children: /* @__PURE__ */ o.jsxs(
                  at,
                  {
                    href: (L = g == null ? void 0 : g.rootProps) == null ? void 0 : L.appLink,
                    disableRipple: !0,
                    className: Se.title,
                    children: [
                      y && /* @__PURE__ */ o.jsx(C, { Component: "span", className: Se.icon, children: y }),
                      ((x = g == null ? void 0 : g.rootProps) == null ? void 0 : x.appName) && !d && /* @__PURE__ */ o.jsx(
                        J,
                        {
                          component: "h1",
                          variant: "h5",
                          weight: "bold",
                          gutterBottom: !1,
                          children: (O = g == null ? void 0 : g.rootProps) == null ? void 0 : O.appName
                        }
                      ),
                      ((E = g == null ? void 0 : g.rootProps) == null ? void 0 : E.isAppBeta) && /* @__PURE__ */ o.jsx(
                        vt,
                        {
                          Component: "span",
                          color: "secondary",
                          label: "BETA",
                          size: "exSmall",
                          className: Se.beta
                        }
                      )
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ o.jsx(C, { className: G(Se.content, s == null ? void 0 : s.content), children: i }),
            /* @__PURE__ */ o.jsxs(C, { className: Se.nav, children: [
              /* @__PURE__ */ o.jsx(Ga, {}),
              /* @__PURE__ */ o.jsx(So, {}),
              /* @__PURE__ */ o.jsx(Ao, {}),
              /* @__PURE__ */ o.jsx(Rr, {}),
              /* @__PURE__ */ o.jsx(Sr, {})
            ] })
          ]
        }
      ),
      /* @__PURE__ */ o.jsx(qa, {})
    ] });
  }
);
Ro.displayName = "AppBar";
const Ao = () => {
  const { appMeta: n } = ve(), e = n.getAppData("Marketplace");
  let t = "";
  return e && (t = n.prepareAppSwitchingURL(e)), /* @__PURE__ */ o.jsx(xe, { title: "Home", arrow: !0, children: /* @__PURE__ */ o.jsx(Ee, { color: "secondary", Component: "a", href: t, children: /* @__PURE__ */ o.jsx(En, {}) }) });
}, So = () => {
  const { appMeta: n } = ve();
  return (n.appHelpURL.length ?? 0) > 0 && /* @__PURE__ */ o.jsx(xe, { title: "Support", arrow: !0, children: /* @__PURE__ */ o.jsx(
    Ee,
    {
      color: "secondary",
      Component: "a",
      href: n.appHelpURL,
      target: "_blank",
      children: /* @__PURE__ */ o.jsx(kn, {})
    }
  ) });
};
export {
  On as APP_ICON_MAPPING,
  Co as AUTH,
  Ro as AppBar,
  Vo as AppProvider,
  zo as AppRootProvider,
  jn as DEFAULT_ADVERTISER_MODELING_CONDITION,
  Wo as DataDogProvider,
  Uo as ENV,
  Fo as INIT,
  At as IQM_PLATFORM_BASIC_AUTH_HEADER,
  Ba as InfoBar,
  Mo as InitProvider,
  Bo as InitRootProvider,
  br as IntercomProvider,
  P as LOCALSTORAGE_KEYS,
  ce as ORGANIZATION_TYPE,
  No as OWID,
  nr as OWID_HEADER_KEY,
  Yo as PlatformDevTools,
  ar as SVG_HOST_PROD_URL,
  or as SVG_HOST_STAGE_URL,
  gr as apiTimingsInterceptor,
  Bt as attachInstance,
  qe as authAppDetail,
  Mn as getAllowedApplications,
  Fn as getAllowedOrganizationList,
  Un as getAllowedOrganizationListKey,
  Wn as getChatBotConfig,
  Vn as getCustomerConfig,
  Tn as getCustomerConfigKey,
  Cn as getInitChatBotConfig,
  Nn as getInitData,
  Ue as getInstance,
  Hn as getNewAccessTokenFromRefreshToken,
  Ne as getProfileAndAllowedAppsKey,
  Bn as getProfileData,
  qn as getProfileDataWithAxiosInstance,
  $n as logoutUser,
  Pn as logoutUserOnTokenExpiryInterceptor,
  ua as useAllowApplicationData,
  ma as useAllowedOrganizationList,
  ve as useAppContext,
  Ge as useAppRootContext,
  la as useChatBotConfig,
  da as useCustomerConfigData,
  wr as useDataDogContext,
  $o as useDatadogTrackViewsManually,
  ga as useInitChatBotConfig,
  ea as useInitContext,
  fa as useInitData,
  Ir as useInitRootContext,
  Zn as useIntercomContext,
  ca as useProfileData,
  pa as useSetupAuthDataInLocalstorage,
  Yn as validateToken
};
//# sourceMappingURL=index.js.map
